import { HTTPService, JsonResultClass } from "../app/core/util/httpManager.js";
import { NotificationHelper } from "../app/core/util/notificationHelper.js";
import { Helper } from "../app/core/util/helper.js";
import { General } from "./general.js";
import { Config } from "../app/core/config/config.js";
import { AnnualVacationViewAppProps } from "../app/vacation/annualVacationView.js";
import { EntityWeeklyReportList, WeeklyReportListAppProps } from "../app/weeklyReportList/weeklyReportList.js";
import { DirectionsAppProps, DirectionsConfig } from "../app/geomap/directions/directions.js";
import { ModuleRightsAppProps } from "../app/moduleRights/moduleRights.js";
import { CurrentLicensePackageInformation } from "../app/userSettings/userModuleAllocation.js";
import { DataCondition, RemindersListAppProps, ReminderViewMode } from "../app/reminders/reminders.js";
import { ServiceHoursProps } from "../app/sla/serviceHours/serviceHours.js";
import { LevelAppProps } from "../app/sla/level/level.js";
import { ActionRight, AgreementAppProps, AgreementEntity } from "../app/sla/agreement/agreement.js";
import { AppReloader } from "../app/core/components/appReloader.js";
import { RecurringTaskAppProps, RecurringTaskEntity } from "../app/tasks/recurringTask/recurringTask.js";
import {
    Innosoft_WebCRM_Statistics_Controllers_SettingsController as SettingsController
} from "../app/statistics/generated_api/generated_api.js"
import { getGlobalSettings } from "../app/statistics/settings.js";
import { UpdateApplicationAppProps } from "../app/updateApplication/updateApplication.js";
import { TaskGroupAppProps, TaskGroupNodeEditEntity } from "../app/taskGroup/taskGroup.js";
import { ReportDefinition, ReportMetaDataProps } from "../app/reportMetaData/reportMetaData.js";
import { PrintJobsProps } from "../app/reportMetaData/printJobs.js";
import { WorkPackageAppProps, WorkPackageEntity } from "../app/tasks/workPackage/workPackage.js";
import { AbsenceOverviewAppProps, AbsenceOverviewEntity } from "../app/absenceOverview/absenceOverview.js";
import { StyleAppProps } from "../app/style/style.js";
import { NukreisSelectionProps } from "../app/nukreis/nukreisSelection.js";
import { TravelReportSearchEntity, TravelReportSearchProps } from "../app/travelReport/travelReportSearch.js";
import { EditTravelReportApp, EditTravelReportProps } from "../app/travelReport/editTravelReport.js";
import {
    CreateMultipleAssignments,
    CreateMultipleAssignmentsProps
} from "../app/createMultipleAssignments/createMultipleAssignments.js";
import { EditFlag, FlagProps } from "../app/generalSettings/flags/editFlag.js";
import DocumentsListApp, { DocumentsListAppProps } from "../app/documents/documents.js";
import AssignmentDistributionWizard, {
    AssignmentDistributionWizardProps
} from "../app/assignmentDistribution/assignmentDistributionWizard.js";
import { EmailTemplateEntity, EmailTemplateProps } from "../app/email/template/template.js";
import { EditIcon, IconProps } from "../app/generalSettings/icons/editIcon.js";
import { ChangeNoticeApp } from "../app/resourcePlanning/changeNotice.js";
import { Documentation } from "../app/help/documentation.js";
import { AdminInfo } from "../app/help/adminInfo.js";
import { startContextLess } from "../app/smartSearch/smartSearch.js";
import { InfoToolJob, InfoToolJobProps } from "../app/infoTool/infoToolJob.js";
import { ConnectedWindow } from "../app/core/components/connectedWindow.js"
import { InnoBotProps, InnoBot } from "../app/innobot/innobot.js";
import { HomeHelper } from "../app/home/home.js";
import { ApplicationRestartAppProps, ApplicationRestartEntity } from "../app/applicationRestart/applicationRestart.js";
import { EntityWeeklyReport } from "../app/weeklyReport/weeklyReportInGrid.js";
import { WeeklyReportAppProps } from "../app/weeklyReport/weeklyReport.js";
import { TravelReportEntity } from "../app/travelReport/travelReportInterfaces.js";
import { DynamicSearchAppProps, DynamicSearchApp } from "../app/dynamicSearch/dynamicSearch.js";
import { SupportZipAppProps, SupportZipEntity } from "../app/supportZip/supportZip.js";
import { ResourcePlanningGroupingEntity, ResourcePlanningGroupingProps } from "../app/resourcePlanningGrouping/resourcePlanningGrouping.js";
import { ResourcePlanningAppProps, ResourcePlanningEntity } from "../app/resourcePlanning/resourcePlanning.js";
import { EmailDataSourceListAppProps } from "../app/email/dataSource/list.js";
import { EntityTicket, TicketApp, TicketAppProps } from "../app/ticket/ticket.js";
import { EntityServiceReport, ServiceReportAppProps } from "../app/serviceReport/serviceReport.js";
import { ContactAppProps, EntityContact } from "../app/contact/contact.js";
import { ErrorAppProps } from "../app/error/error.js";
import { ProjectManagementTimesAppProps, ProjectManagementTimesEntity } from "../app/projectManagementTimes/projectManagementTimes.js";
import { EntityMachine, MachineAppProps } from "../app/machine/machine.js";
import AddressApp, { AddressAppProps, EntityAddress } from "../app/address/address.js";
import { FlexTimeEntity, FlexTimeProps } from "../app/flextime/flextime.js";
import { EditReportAppProps } from "../app/editReport/editReport.js";
import { CockpitAppProps, CockpitStarterEntity } from "../app/cockpit/cockpit.js";
import { EmailTemplateListAppProps } from "../app/email/template/list.js";
import { EmailDataSourceEntity, EmailDataSourceProps } from "../app/email/dataSource/dataSource.js";
import { ChangePasswordAppProps } from "../app/changePassword/changePassword.js";
import { EmailHistoryAppProps } from "../app/email/history.js";
import { ActionLocksEntity, ActionLocksProps } from "../app/actionlocks/actionlocks.js";
import { EmailAppProps, EmailEntity } from "../app/email/email.js";
import { ResourcePlanningPMAppProps, ResourcePlanningPMEntity } from "../app/resourcePlanningPM/resourcePlanningPM.js";
import { EntityResource, ResourceAppProps } from "../app/resource/resource.js";
import { EntityParts, PartsAppProps } from "../app/parts/parts.js";
import { EntityServiceReportList, ServiceReportListAppProps } from "../app/serviceReportList/serviceReportList.js";
import { EntityUserSettings, UserSettingsAppProps } from "../app/userSettings/userSettings.js";
import { EntityProject, ProjectAppProps } from "../app/project/project.js";
import { GeneralSettingsAppProps, GeneralSettingsEntity } from "../app/generalSettings/generalSettings.js";
import { CRTemplateProps } from "../app/crReport/crTemplate.js";
import { AppBaseProps, Entity, Metadata } from "../app/core/components/commonApp.js";
import { KeyValuePair, StringKeyDictionary, StringOrDate } from "../app/commonInterfaces.js";
import { IntegrationProtocolProps, EntityIntegrationProtocol } from "../app/integrationProtocol/integrationProtocol.js";
import { EditBookmarks } from "../app/bookmark/editBookmarks.js";
import { SemanticSearchApp } from "../app/semanticSearch/main.js";
import { WarehouseApp, WarehouseAppProps } from "../app/warehouse/warehouse.js";
import Stocks, { StocksProps, Warehouse } from "../app/stock/stocks.js";
import { StocksService } from "../app/stock/stocksService.js";
import CRTemplate from "../app/crReport/crTemplate.js";
import { EmailApp } from "../app/email/email.js";
import { requireBase } from "../app/core/require.js"
import React from "react"
//////////////
/// A P P S///
//////////////


const startDynamicSearch: LauncherAction<DynamicSearchData> = (launcherConfig, launcherData) => {
    const cusParamUrl = launcherData.customParameters ? "&" + $.param(launcherData.customParameters) : "";

    HTTPService.chainBatch
        .add<JsonResultClass>(`DynamicSearch/Init/?searchType=${getUriParameter(launcherData.searchType)}&isWindow=${launcherConfig.isWindow}&isMulti=${launcherData.isMulti}&fullObject=${launcherData.fullObject}${cusParamUrl}`)
        .add<Metadata>(Helper.getMetaData('DynamicSearch/' + getUriParameter(launcherData.searchType)))
        .add<JsonResultClass<StringKeyDictionary<string>>>(Helper.getTranslations(["Suche.NoTemplate", "Suche.NewTemplate", "Suche.Suchvorlagen", "Suche.VorlageName",
            "Suche.AutoSearch", "Suche.VorlageNameNichtNull", "Suche.VorlageNameVergeben", "Suche.QuickSearch", "Suche.FreeTextSearch", "Suche.ShowDetails"]))
        .promise()
        .then(result => {
            const modelData = result[0];
            if (modelData.Code > 0) {
                NotificationHelper.showErrorMessage(modelData.Message);
            } else {
                const props: DynamicSearchAppProps = {
                    useDefaultImages: modelData.Data.UseDefaultImages,
                    searchType: launcherData.searchType,
                    isWindow: launcherConfig.isWindow,
                    title: launcherConfig.title,
                    metadata: result[1],
                    context: { contextType: "dynamicSearch" },
                    config: modelData.Data,
                    translations: result[2].Data,
                    multiSelectPattern: launcherData.displayPattern,
                    queryParameters: launcherData.queryParameters,
                    customParameters: launcherData.customParameters,
                    newParameters: launcherData.newParameters,
                    quick: launcherData.quick,
                    fullObject: launcherData.fullObject,
                    isIFrame: launcherData.iFrame,
                    withSkills: launcherData.withSkills,
                    skillsTranslations: launcherData.skillsTranslations
                };
                showAppWithEditorSupport(DynamicSearchApp, props);
            }
        });

}

const startAddress: LauncherAction = (launcherConfig, launcherData) => {

    HTTPService.chainBatch
        .add<JsonResultClass<EntityAddress>>('Address/Init/?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("address"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: AddressAppProps = {
                    context: { key1: "entity.AdrNr", keyVal1: launcherConfig.keyValue, contextType: "address" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(AddressApp, props);
            }
        });
}

const startCRTemplate: LauncherAction = async (launcherConfig, launcherData) => {

    let currentTemplateId = getUriParameter(launcherConfig.keyValue);
    const getData = async (templateId): Promise<CRTemplateProps> => {
        const result = await HTTPService.chainBatch
            .add<JsonResultClass>('CrTemplate/Init/?Id=' + templateId)// getUriParameter(launcherConfig.keyValue))
            .add<Metadata>(Helper.getMetaData("crTemplate"))
            .promise()

        const entity = result[0];
        if (entity.Code > 0) {
            NotificationHelper.showErrorMessage(entity.Message);
        } else {
            const props: CRTemplateProps = {
                context: { contextType: "crTemplate", keyVal1: templateId, key1: "entity.ISGuid" },
                title: launcherConfig.title,
                entity: entity.Data,
                metadata: result[1],
                dataSources: {},
                isWindow: launcherConfig.isWindow
            };
            return props;
        }
    }

    const reloadTab = (): Promise<CRTemplateProps> => {
        return getData(currentTemplateId);
    }

    const changeRoute = (newTemplateId): Promise<CRTemplateProps> => {
        currentTemplateId = newTemplateId;
        General.Functions.HistoryState.replaceState("CRTemplate/Edit?Id=" + currentTemplateId);
        return reloadTab();
    }

    General.Content.MountComponent(AppReloader, { childApp: CRTemplate, reloadTab: reloadTab, changeRoute: changeRoute });
}

import CRTemplateList from "../app/crReport/crTemplate_list.js";
const startCRTemplateList: LauncherAction = async (launcherConfig, launcherData) => {

    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("crTemplate_list"))
        .promise()
        .then((result) => {
            const entity = result[0];
            const props: AppBaseProps = {
                context: { key1: "entity.ID", keyVal1: launcherConfig.keyValue, contextType: "crTemplate_list" },
                title: launcherConfig.title,
                entity: {
                    IsNew: false,
                    IsWatchable: false,
                    IsWatched: false,
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true,
                    }
                },
                metadata: result[0],
                dataSources: {
                },
                isWindow: launcherConfig.isWindow
            };

            showAppWithEditorSupport(CRTemplateList, props);
        }
        );
}

import CRQuestion from "../app/crReport/crQuestion.js";
const startCRQuestion: LauncherAction = async (launcherConfig, launcherData) => {
    let currentQuestionId = getUriParameter(launcherConfig.keyValue);

    const getData = async (questionId): Promise<any> => {
        const result = await HTTPService.chainBatch
            .add<JsonResultClass>('CRQuestion/Init/?Id=' + questionId)
            .add<Metadata>(Helper.getMetaData("crQuestion"))
            .promise();

        const entity = result[0];
        if (entity.Code > 0) {
            NotificationHelper.showErrorMessage(entity.Message);
        } else {
            const props = {
                context: { contextType: "crQuestion" },
                title: launcherConfig.title,
                entity: entity.Data,
                metadata: result[1],
                dataSources: {},
                isWindow: launcherConfig.isWindow,
                draftId: result[0].AdditionalData.DraftId
            };
            return props;
        };
    };

    const reloadTab = (): Promise<any> => {
        return getData(currentQuestionId);
    }

    const changeRoute = (newTemplateId): Promise<any> => {
        currentQuestionId = newTemplateId;
        General.Functions.HistoryState.replaceState("CRQuestion/Edit?Id=" + currentQuestionId);
        return reloadTab();
    }


    General.Content.MountComponent(AppReloader, { childApp: CRQuestion, reloadTab: reloadTab, changeRoute: changeRoute });
}

import PartsApp from "../app/parts/parts.js";
const startParts: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<EntityParts>>('Parts/Init?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("parts"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: PartsAppProps = {
                    context: { key1: "entity.ArtNr", keyVal1: launcherConfig.keyValue, contextType: "Parts" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(PartsApp, props);
            }
        });
}

const startEmailSender: LauncherAction<EmailSenderData> = async (launcherConfig, launcherData) => {
    const forward = launcherConfig.action.toLowerCase() === "forward";
    let url = 'EmailSender/Init?id=' + getUriParameter(launcherData.id) + "&documentids=" + getUriParameter(launcherData.documentids);
    if (forward) {
        url = 'EmailSender/InitForward?jobId=' + getUriParameter(launcherData.id) + "&respondeToMailId=" + getUriParameter(launcherData.respondeToMailId);
    }
    const [entity, metaData] = await Promise.all([
        HTTPService.get<JsonResultClass<EmailEntity>>(url),
        Helper.getMetaData("emailSender")
    ]);
    const props: EmailAppProps = {
        context: {
            key1: "entity.Id",
            keyVal1: launcherData.id,
            contextType: "email",
            filesEnabled: launcherData.filesEnabled,
            documentsEnabled: launcherData.docsEnabled,
            appContext: launcherData.type,
            itemKey: launcherData.itemKey,
            contextUrl: launcherData.targetUrl,
            defaultTemplate: launcherData.defaultTemplate,
            forward: forward,
            notAllowedDocumentFileTypes: launcherData.notAllowedDocumentFileTypes
        },
        title: launcherConfig.title,
        entity: entity.Data,
        metadata: metaData,
        dataSources: {},
        isWindow: launcherConfig.isWindow,
        senderName: launcherData.senderName,
        senderEmail: launcherData.senderEmail,
        receiver: launcherData.receiver,
        cc: launcherData.cc,
        bcc: launcherData.bcc,
        subject: launcherData.subject,
        respondeToMailId: launcherData.respondeToMailId,
        templateLanguageCode: launcherData.templateLanguageCode,
        openLanguageSelection: launcherData.openLanguageSelection,
        answerToAll: launcherData.answerToAll,

    };
    showAppWithEditorSupport(EmailApp, props);
}

import { HistoryApp } from "../app/email/history.js";
const startEmailHistory: LauncherAction<EmailHistoryData> = (launcherConfig, launcherData) => {
    Helper.getMetaData("emailHistory")
        .then(result => {
            const entity = Helper.createEmptyEntity();
            entity.IsNew = false;

            const props: EmailHistoryAppProps = {
                context: {
                    contextType: "emailHistory",
                    appContext: launcherData.type,
                    itemKey: launcherData.itemKey,
                    jobId: launcherData.jobId,
                    key1: null,
                    keyVal1: null
                },
                title: launcherConfig.title,
                entity: entity,
                metadata: result,
                isWindow: launcherConfig.isWindow,
                dataSources: null
            };
            showAppWithEditorSupport(HistoryApp, props);
        });
}
import { ActionLocksApp } from "../app/actionlocks/actionlocks.js";
const startActionLocksEdit: LauncherAction<ActionLocksEditData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<ActionLocksEntity>>('ActionLocks/InitActionLocks/' + (Helper.hasValue(launcherData.id) ? "?id=" + getUriParameter(launcherData.id) : ""))
        .add<Metadata>(Helper.getMetaData("editActionLocks"))
        .promise()
        .then(result => {
            const props: ActionLocksProps = {
                context: { key1: "entity.Id", keyVal1: launcherData.id, contextType: "editActionLocks" },
                title: launcherConfig.title,
                entity: result[0].Data,
                metadata: result[1],
                dataSources: {},
                isWindow: launcherConfig.isWindow,
            };
            showAppWithEditorSupport(ActionLocksApp, props);
        });
}
import { ActionLocksRightsApp } from "../app/actionlocks/actionlocksrights";
const startActionLocksRightsEdit: LauncherAction<ActionLocksRightsEditData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<ActionLocksEntity>>('ActionLocks/InitActionLocksRights/?aktionid=' + getUriParameter(launcherData.aktionId) + (Helper.hasValue(launcherData.id) ? "&id=" + getUriParameter(launcherData.id) : ""))
        .add<Metadata>(Helper.getMetaData("editActionLocksRights"))
        .promise()
        .then(result => {
            const props: ActionLocksProps = {
                context: { key1: "entity.Id", keyVal1: launcherData.id, contextType: "editActionLocksRights" },
                title: launcherConfig.title,
                entity: result[0].Data,
                metadata: result[1],
                dataSources: {},
                isWindow: launcherConfig.isWindow,
            };
            showAppWithEditorSupport(ActionLocksRightsApp, props);
        });
}

import { EmailTemplateApp } from "../app/email/template/template.js";
const startEmailTemplateEdit: LauncherAction<EmailTemplateEditData> = async (launcherConfig, launcherData) => {
    const results = await Promise.all([
        HTTPService.get<JsonResultClass<EmailTemplateEntity>>(`EmailSender/InitTemplate/?id=${(launcherData.id || "")}&type=${(launcherData["type"] || "")}`),
        Helper.getMetaData("emailTemplate")
    ])
    const props: EmailTemplateProps = {
        context: { key1: "entity.Id", keyVal1: launcherData.id, contextType: "emailTemplate" },
        title: launcherConfig.title,
        entity: results[0].Data,
        metadata: results[1],
        dataSources: {},
        isWindow: launcherConfig.isWindow,
        disableEntityType: Helper.hasValue(launcherData["disableType"]) && (launcherData["disableType"] as boolean)
    };
    showAppWithEditorSupport(EmailTemplateApp, props);
}

import { AttendanceClockApp } from "../app/attendanceclock/attendanceclock.js";
const startAttendanceClock: LauncherAction = async (launcherConfig, launcherData) => {
    const results = await Promise.all([
        HTTPService.get<JsonResultClass>(`AttendanceClock/Init`),
        Helper.getMetaData("attendanceclock")
    ]);

    if (results[0].Code > 0)
        showErrorPage(results[0].Message, results[0].AdditionalData)
    else {
        const props: AppBaseProps = {
            context: { key1: "", keyVal1: null, contextType: "attendanceclock" },
            entity: Helper.createEmptyEntity(),
            metadata: results[1],
            dataSources: {},
            isWindow: false,
        };
        showAppWithEditorSupport(AttendanceClockApp, props);
    }
}

import { FlexTimeApp } from "../app/flextime/flextime.js";
const startFlexTime: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<FlexTimeEntity>>("FlexTime/GetFlexTimeData")
        .add<Metadata>(Helper.getMetaData("flextime"))
        .promise()
        .then(result => {
            const props: FlexTimeProps = {
                context: { key1: "", keyVal1: null, contextType: "flextime" },
                entity: result[0].Data,
                metadata: result[1],
                dataSources: {},
                isWindow: launcherConfig.isWindow,
            };
            showAppWithEditorSupport(FlexTimeApp, props);
        });
}

import { EmailTemplateListApp } from "../app/email/template/list.js";
const startEmailTemplatesList: LauncherAction<EmailTemplatesListData> = (launcherConfig, launcherData) => {
    Helper.getMetaData("emailTemplateList")
        .then(result => {
            const entity = Helper.createEmptyEntity();
            entity.IsNew = false;

            const props: EmailTemplateListAppProps = {
                context: { contextType: "emailTemplatesList", templateType: launcherData.templateType },
                entity: entity,
                metadata: result,
                isWindow: launcherConfig.isWindow,
                dataSources: null
            };
            showAppWithEditorSupport(EmailTemplateListApp, props);
        });
}

import { EmailDataSourceApp } from "../app/email/dataSource/dataSource";
const startEmailDataSourceEdit: LauncherAction<EmailDataSourceEditData> = (launcherConfig, launcherData) => {
    let url = `EmailSender/InitDataSource/?id=${(launcherData.id)}`;
    if ((launcherData["type"])) {
        url += `&type=${(launcherData["type"])}`
    }

    HTTPService.chainBatch
        .add<JsonResultClass<EmailDataSourceEntity>>(url)
        .add<Metadata>(Helper.getMetaData("emailDataSource"))
        .promise()
        .then(result => {
            const props: EmailDataSourceProps = {
                context: { key1: "entity.Id", keyVal1: launcherData.id, contextType: "emailDataSource" },
                title: launcherConfig.title,
                entity: result[0].Data,
                metadata: result[1],
                dataSources: {},
                isWindow: launcherConfig.isWindow,
                disableEntityType: Helper.hasValue(launcherData["disableType"]) && (launcherData["disableType"] as boolean)
            };
            showAppWithEditorSupport(EmailDataSourceApp, props);
        });
}

import { EmailDataSourceListApp } from "../app/email/dataSource/list.js";
const startEmailDataSourcesList: LauncherAction<EmailDataSourcesListData> = (launcherConfig, launcherData) => {
    Helper.getMetaData("emailDataSourceList")
        .then(result => {
            const entity = Helper.createEmptyEntity();
            entity.IsNew = false;

            const props: EmailDataSourceListAppProps = {
                context: { contextType: "emailDataSourceList", sourceType: launcherData.sourceType },
                title: launcherConfig.title,
                entity: entity,
                metadata: result,
                isWindow: launcherConfig.isWindow,
                dataSources: null
            };
            showAppWithEditorSupport(EmailDataSourceListApp, props);
        });
}

import ChangePasswordApp from "../app/changePassword/changePassword.js";
const startChangePassword: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass>('Account/InitChangePasswordModel')
        .add<Metadata>(Helper.getMetaData("changePassword"))
        .promise()
        .then(result => {
            const props: ChangePasswordAppProps = {
                context: { key1: "", keyVal1: null, contextType: "changePassword" },
                title: launcherConfig.title,
                entity: result[0].Data,
                metadata: result[1],
                dataSources: {},
                isWindow: false,
                extendedLoginActive: result[0].AdditionalData["ExtendedLoginActive"]
            };
            showAppWithEditorSupport(ChangePasswordApp, props);
        });
}

import CockpitApp from "../app/cockpit/cockpit.js"
const startCockpit: LauncherAction<CockpitData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<CockpitStarterEntity>>("Cockpit/Init?adrNr=" + getUriParameter(launcherData.adrNr))
        .add<Metadata>(Helper.getMetaData("cockpit"))
        .promise()
        .then(result => {
            const entity = result[0];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: CockpitAppProps = {
                    context: { key1: "entity.AdrNr", keyVal1: launcherData.adrNr, contextType: "cockpit" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    isWindow: false,
                    dataSources: null,
                    address: launcherData.adrNr,
                    machine: launcherData.maschNr,
                    contact: launcherData.pos
                };
                showAppWithEditorSupport(CockpitApp, props);
            }
        });
}

import CommercialDocumentApp from "../app/commercialDocuments/commercialDocument.js"
const startCommercialDocument: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<any>>("CommercialDocumentNG/Init?id=" + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("commercialDocument"))
        .add<Metadata>(Helper.getMetaData("commercialDocumentLineItem"))
        .promise()
        .then(result => {
            const entity = result[0];
            const metadata = result[1];
            const metatdatLineItem = result[2];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: any = {
                    context: { key1: "entity.Id", keyVal1: launcherConfig.keyValue, contextType: "commercialDocument" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: metadata,
                    metadataLineItem: metatdatLineItem,
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(CommercialDocumentApp, props);
            }
        });
}

import ContactApp from "../app/contact/contact.js";
const startContact: LauncherAction<ContactData> = (launcherConfig, launcherData) => {
    let initUrl = "Contact/Init?id=" + getUriParameter(launcherConfig.keyValue);
    if (Helper.hasValue(launcherData.adrNr) && launcherData.adrNr !== "") {
        initUrl += "&adrNr=" + getUriParameter(launcherData.adrNr);
    }
    HTTPService.chainBatch
        .add<JsonResultClass<EntityContact>>(initUrl)
        .add<Metadata>(Helper.getMetaData("contact"))
        .promise()
        .then(result => {
            const entity = result[0];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                if (!Helper.isNullOrEmpty(launcherData["email"]))
                    entity.Data.Email1 = launcherData["email"];
                const props: ContactAppProps = {
                    context: { key1: "entity.Pos", keyVal1: launcherConfig.keyValue, contextType: "contact" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(ContactApp, props);
            }
        });
}

import { ModuleRightsApp } from "../app/moduleRights/moduleRights.js";
const startAdmin: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<CurrentLicensePackageInformation>>('Admin/GetLicenseInformation')
        .add('Admin/GetLoggedOnUsers')
        .add("Admin/GroupData")
        .add("TranslationService/AdminModule?lang=" + Config.user.languageId)
        .add<Metadata>(Helper.getMetaData("moduleRights"))
        .promise()
        .then(result => {
            const licenseInfo = result[0].Data;
            const users = result[1];
            const groupData = result[2];
            const translations = result[3];
            const metaData = result[4];
            const props: ModuleRightsAppProps = {
                title: translations["INDEX_NAVBAR_HEADER"],
                licenseInfo: licenseInfo,
                users: users,
                translations: translations,
                groupData: groupData,
                metadata: metaData
            };
            showAppWithEditorSupport(ModuleRightsApp, props);
        });
}

import GeneralSettingsApp from "../app/generalSettings/generalSettings.js";
const startGeneralSettings: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<GeneralSettingsEntity>>("GeneralSettings/Get")
        .add<Metadata>(Helper.getMetaData("generalSettings"))
        .promise()
        .then(result => {
            const entity = result[0];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: GeneralSettingsAppProps = {
                    context: { key1: "", keyVal1: null, contextType: "generalSettings" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };
                showAppWithEditorSupport(GeneralSettingsApp, props);
            }
        });
}

import { LocksApp } from "../app/locks/locks.js";
const startLocks: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("locks")
        .then(result => {
            const props: AppBaseProps = {
                context: { key1: "", keyVal1: null, contextType: "locksGrids" },
                title: launcherConfig.title,
                entity: Helper.createEmptyEntity(),
                metadata: result,
                dataSources: {},
                isWindow: false,
            };
            General.Content.MountComponent(LocksApp, props);
        });
}

import { ActionLocksApp as ActionLocksAppList } from "../app/actionlocks/list.js";
const startActionLocks: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("actionlocksList")
        .then(result => {
            const props: AppBaseProps = {
                context: { key1: "", keyVal1: null, contextType: "actionlocksList" },
                title: launcherConfig.title,
                entity: Helper.createEmptyEntity(),
                metadata: result,
                dataSources: {},
                isWindow: false,
            };
            showAppWithEditorSupport(ActionLocksAppList, props);
        });
}

import { GeocodeDataApp } from "../app/geocode/geocodeData.js";
const startGoocodeData: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("geocodeData")
        .then(result => {
            const props: AppBaseProps = {
                context: { key1: "", keyVal1: null, contextType: "geocodeData" },
                title: launcherConfig.title,
                entity: Helper.createEmptyEntity(),
                metadata: result,
                dataSources: {},
                isWindow: false,
            };
            showAppWithEditorSupport(GeocodeDataApp, props);
        });
}

import { MachineApp } from "../app/machine/machine.js";
const startMachine: LauncherAction<MachineData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<EntityMachine>>('Machine/Init/?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("machine"))
        .promise()
        .then(result => {
            const entity = result[0];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: MachineAppProps = {
                    context: {
                        key1: "entity.MaschNr",
                        keyVal1: launcherConfig.keyValue,
                        contextType: "machine",
                        initAddress: launcherData.address
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow,
                };

                showAppWithEditorSupport(MachineApp, props);
            }
        });
}

const startTicket: LauncherAction<TicketData> = (launcherConfig, launcherData) => {
    if (launcherConfig.action.toLowerCase() !== "new" && !Helper.hasValue(launcherConfig.keyValue)) {
        showErrorPage("Keine Ticketnummer angegeben", {});
        return;
    }
    const getDataUrl =
        Helper.hasValue(launcherConfig.keyValue) ?
            `Procedure/Get/?id=${getUriParameter(launcherConfig.keyValue)}&readOnly=${launcherData.readOnly}` :
            `Procedure/Init/?id=${getUriParameter(launcherData.id)}&id2=${getUriParameter(launcherData.id2)}&id3=${getUriParameter(launcherData.id3)}&id4=${getUriParameter(launcherData.id4)}`;
    HTTPService.chainBatch
        .add<JsonResultClass<EntityTicket>>(getDataUrl)
        .add<Metadata>(Helper.getMetaData("procedure"))
        .promise()
        .then(result => {
            const entity = result[0];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: TicketAppProps = {
                    context: {
                        key1: "entity.ProblemNr",
                        keyVal1: launcherConfig.keyValue,
                        contextType: "ticket",
                        conversationMode: launcherData.conversationMode,
                        isEntitySaved: null,
                        reloadEntity: null,
                        translations: null,
                        isTIDActive: launcherData.isTIDActive,
                        isCopyMaterialToMashActive: launcherData.isCopyMaterialToMashActive
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow,
                    externalStatusDependsOnTicketType: launcherData.externalStatusDependsOnTicketType,
                    externalStatusChangesHotliner: launcherData.externalStatusChangesHotliner,
                    cascadingCodes: launcherData.cascadingCodes,
                    readOnly: launcherData.readOnly,
                    enableEditButton: Helper.getValueOrDefault(entity.AdditionalData.enableEditButton, false) as boolean
                };
                showAppWithEditorSupport(TicketApp, props);
            }
        });
}

const startCustomApp: LauncherAction<CustomerAppData> = (launcherConfig, launcherData) => {
    requireBase("/siteManagement", [launcherData.moduleName], (response) => {
        const props = {
            context: { key1: "", keyVal1: null, contextType: launcherData.contextType },
            title: launcherConfig.title,
            entity: {
                IsNew: false, RecordRight: { CanRead: true, CanWrite: true }, IsWatchable: false, IsWatched: false, launcherData
            },
            metadata: {
                tabs: [], additional: { objects: [] }
            },
            dataSources: {},
            isWindow: launcherConfig.isWindow
        };
        General.Content.MountComponent(response[launcherData.appName], props);
    });
}

import { ProjectApp } from "../app/project/project.js";
const startProject: LauncherAction<ProjectData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<EntityProject>>(Helper.hasValue(launcherConfig.keyValue) ? 'Project/Get/?id=' + getUriParameter(launcherConfig.keyValue) : 'Project/Init')
        .add<Metadata>(Helper.getMetaData("project"))
        .promise()
        .then(result => {
            const entity = result[0];
            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: ProjectAppProps = {
                    context: {
                        key1: "entity.Projnr",
                        keyVal1: launcherConfig.keyValue,
                        contextType: "project",
                        initAddress: launcherData.address,
                        initMachine: launcherData.machine,
                        initTicket: launcherData.ticket,
                        initMainGroup: launcherData.ogrnr
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow,
                    canAddAssignment: launcherData.canAddAssignment
                };

                showAppWithEditorSupport(ProjectApp, props);
            }
        });
}

import { ResourcePlanningGroupingApp } from "../app/resourcePlanningGrouping/resourcePlanningGrouping.js";
const startResourcePlanningGrouping: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("resourcePlanningGrouping")
        .then(result => {
            const entity = Helper.createEmptyEntity() as ResourcePlanningGroupingEntity;
            entity.IsNew = false;
            entity.RecordRight.CanWrite = false;
            entity.pIndex = launcherConfig.secondKeyValue;
            entity.projNr = launcherConfig.keyValue;
            entity.title = launcherConfig.title;
            entity.grouping = launcherData["grouping"];


            const props: ResourcePlanningGroupingProps = {
                context: {
                    key1: "entity.projNo",
                    keyVal1: launcherConfig.keyValue,
                    key2: "entity.projNr",
                    keyVal2: launcherConfig.secondKeyValue,
                    contextType: "resourcePlanningGrouping"
                },
                title: launcherConfig.title,
                entity: entity,
                metadata: result,
                dataSources: {},
                isWindow: launcherConfig.isWindow,
            };
            showAppWithEditorSupport(ResourcePlanningGroupingApp, props);

        });
}

import { ProjectManagementTimesApp } from "../app/projectManagementTimes/projectManagementTimes.js";
const startProjectmanagementTimes: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<ProjectManagementTimesEntity>>(`ProjectManagementTimes/Init/?projNo=${getUriParameter(launcherConfig.keyValue)}&pIndex=${launcherConfig.secondKeyValue}&ressNr=${getUriParameter(launcherData["ressNr"])}`)
        .add<Metadata>(Helper.getMetaData("projectManagementTimes"))
        .promise()
        .then(result => {
            let entity = result[0];
            entity.Data.RecordRight.CanWrite = entity.Data.RecordRight.CanWrite && (Helper.getValueOrDefault(launcherData["canWrite"], true) as boolean)
            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: ProjectManagementTimesAppProps = {
                    context: {
                        key1: "entity.ProjNo",
                        keyVal1: launcherConfig.keyValue,
                        key2: "entity.PIndex",
                        keyVal2: launcherConfig.secondKeyValue,
                        contextType: "projectManagementTimes"
                    },
                    title: null,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow,
                };
                showAppWithEditorSupport(ProjectManagementTimesApp, props);
            }
        });
}

import ResourceApp from "../app/resource/resource.js"
const startResource: LauncherAction<ResourceData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<EntityResource>>("Resource/Init/?id=" + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("resource"))
        .promise()
        .then(result => {
            const entity = result[0];
            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                if (!Helper.isNullOrEmpty(launcherData["email"]))
                    entity.Data.Email1 = launcherData["email"];

                const props: ResourceAppProps = {
                    context: {
                        key1: "entity.Ressnr",
                        keyVal1: launcherConfig.keyValue,
                        contextType: "resource",
                        standardWorkTime: launcherData.standardWorkTime,
                        ressurlaubGridOptions: null,
                        translations: null,
                        vacationListGridOptions: null,
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow,
                };
                showAppWithEditorSupport(ResourceApp, props);
            }
        });
}

import ServerProtokollApp from "../app/serverProtokoll/serverProtokoll.js";
const startServerprotokoll: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add("ServerProtokoll/GetGridData")
        .add<Metadata>(Helper.getMetaData("serverProtokoll"))
        .promise()
        .then(result => {
            const jsonResult = result[0];
            const metadata = result[1];
            const props: any = {
                context: "serverProtokoll",
                title: launcherConfig.title,
                entity: jsonResult.Data,
                metadata: metadata,
                dataSources: {
                },
                isWindow: launcherConfig.isWindow
            };
            General.Content.MountComponent(ServerProtokollApp, props);
            //showAppWithEditorSupport(ServerProtokollApp, props);
        });
}

import ServerTemplateEditApp from "../app/serverTemplate/serverTemplateEdit.js";
const startServerTemplateNew: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add("ServerTemplate/InitTemplate?isNew=" + "true")
        .add<Metadata>(Helper.getMetaData("editServerTemplate"))
        .promise()
        .then(result => {
            const entity = result[0];
            const metadata = result[1];

            const props: any = {
                context: "serverTemplateEdit",
                title: launcherConfig.title,
                metadata: metadata,
                entity: entity.Data,
                saveUrl: "ServerTemplate/SaveTemplate",
                dataSources: {
                },
                isWindow: launcherConfig.isWindow
            };
            showAppWithEditorSupport(ServerTemplateEditApp, props);
        });
}

const startServerTemplateEdit: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add("ServerTemplate/InitTemplate?isNew=" + "false")
        .add<Metadata>(Helper.getMetaData("editServerTemplate"))
        .promise()
        .then(result => {
            const entity = result[0];
            const metadata = result[1];

            const props: any = {
                context: "serverTemplateEdit",
                title: launcherConfig.title,
                metadata: metadata,
                entity: entity.Data,
                saveUrl: "ServerTemplate/SaveTemplate",
                dataSources: {
                },
                isWindow: launcherConfig.isWindow
            };
            showAppWithEditorSupport(ServerTemplateEditApp, props);
        });
}

import ServerJobApp from "../app/serverJob/serverJob.js";
const startServerJob: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add("ServerJob/InitData?id=" + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("serverJob"))
        .promise()
        .then(result => {
            const entity = result[0];
            const metadata = result[1];

            const props: any = {
                context: { contextType: "serverJob", translations: null },
                title: launcherConfig.title,
                metadata: metadata,
                entity: entity.Data,
                saveUrl: "ServerJob/Save",
                dataSources: {
                },
                isWindow: launcherConfig.isWindow
            };
            showAppWithEditorSupport(ServerJobApp, props);
        });
}

import ServerTemplateExecuteApp from "../app/serverTemplate/serverTemplateExecute.js";
const startServerTemplateExecute: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add("ServerTemplate/InitData")
        .add<Metadata>(Helper.getMetaData("serverTemplateExecute"))
        .promise()
        .then(result => {
            const entity = result[0];
            const metadata = result[1];
            const props: any = {
                context: { contextType: "serverTemplateExecute", translations: null },
                title: launcherConfig.title,
                metadata: metadata,
                entity: entity.Data,
                doNotUpdateBrowserTitle: true,
                dataSources: {
                },
                isWindow: launcherConfig.isWindow
            };
            showAppWithEditorSupport(ServerTemplateExecuteApp, props);
        });
}

import VacationPlanning from "../app/vacationPlanning/vacationPlanning.js";
const startVacationPlanning: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add("VacationPlanning/InitData")
        .add<Metadata>(Helper.getMetaData("vacationPlanning"))
        .promise()
        .then(result => {
            const entity = result[0];
            const metadata = result[1];

            const props = {
                context: { contextType: "vacationPlanning", translations: null },
                title: launcherConfig.title,
                metadata: metadata,
                entity: entity.Data,
                saveUrl: "VacationPlanning/Save",
                dataSources: {
                },
                isWindow: launcherConfig.isWindow,
                connectedToRessource: !Helper.isNullOrEmpty(entity.Data.RessNr)
            };
            showAppWithEditorSupport(VacationPlanning, props);
        });
}

type UserSettingsContext = 'userSettings' | 'roleSettings';

import { UserSettingsApp } from "../app/userSettings/userSettings.js";
const startUserOrRoleSettings = (contextType: UserSettingsContext) => async (launcherConfig, launcherData) => {
    let userName = launcherConfig.keyValue || Config.user.userName;

    const [entity, metadata, metadataUserSettingsApply, ressourcenSortierungskriterienDs] = await Promise.all([
        HTTPService.get<JsonResultClass<EntityUserSettings>>(`UserSettings/Get/?id=${getUriParameter(userName)}`),
        Helper.getMetaData(contextType),
        Helper.getMetaData("userSettingsApply"),
        HTTPService.get("ResourcePlanningLookup/GetRessourcenSortierungskriterien"),
    ]);


    const props: UserSettingsAppProps = {
        context: { key1: "entity.User.Name", keyVal1: userName, contextType: contextType },
        title: launcherConfig.title,
        entity: entity.Data,
        useAddresstypePermission: entity.AdditionalData["useAddresstypePermission"],
        metadata: metadata,
        metadataUserSettingsApply: metadataUserSettingsApply,
        dataSources: {
            ressourcenSortierungskriterium1DataSource: ressourcenSortierungskriterienDs,
            ressourcenSortierungskriterium2DataSource: JSON.parse(JSON.stringify(ressourcenSortierungskriterienDs)),
            ressourcenSortierungskriterium3DataSource: JSON.parse(JSON.stringify(ressourcenSortierungskriterienDs)),
            codeCounterModes: [
                {
                    text: Helper.getTranslation("WebSMS.UserSettings.LegendeCounter.Aus"),
                    value: 0
                }, {
                    text: Helper.getTranslation("WebSMS.UserSettings.LegendeCounter.OnlyResources"),
                    value: 1
                }, {
                    text: Helper.getTranslation("WebSMS.UserSettings.LegendeCounter.OnlyContainer "),
                    value: 2
                }, {
                    text: Helper.getTranslation("WebSMS.UserSettings.LegendeCounter.All"),
                    value: 3
                }
            ],
            wholeDaysRenderMode: [
                {
                    text: Helper.getTranslation("WebCRM.Administration.OnlyShortAssignments"),
                    value: 0
                }, {
                    text: Helper.getTranslation("WebCRM.Administration.AllAssignments"),
                    value: 1
                }
            ],
            multipleOccupancyOptions: [
                {
                    text: Helper.getTranslation("Regionen.PlantafelEinstellungen.CheckMultipleOccupancy.Allow"),
                    value: 0
                },
                {
                    text: Helper.getTranslation("Regionen.PlantafelEinstellungen.CheckMultipleOccupancy.Forbid"),
                    value: 1
                },
                {
                    text: Helper.getTranslation("Regionen.PlantafelEinstellungen.CheckMultipleOccupancy.Ask"),
                    value: 2
                }
            ]
        },
        isWindow: launcherConfig.isWindow
    };
    showAppWithEditorSupport(UserSettingsApp, props);
}

import { UpdateApplicationApp } from "../app/updateApplication/updateApplication.js";
const startUpdateApplication: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("updateApplication"))
        .add<JsonResultClass<{}>>("UpdateApplication/GetConfigurationSettings")
        .promise()
        .then(result => {
            const props: UpdateApplicationAppProps = {
                context: { key1: "", keyVal1: null, contextType: "updateApplication" },
                title: launcherConfig.title,
                entity: Helper.createEmptyEntity(),
                metadata: result[0],
                dataSources: {},
                isWindow: false,
                debugModeOn: result[1].Data["debugModeOn"]
            };
            showAppWithEditorSupport(UpdateApplicationApp, props);
        });
}

import { UpdateLicenseApp } from "../app/updateLicense/updateLicense.js";
const startUpdateLicense: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("updateLicense")
        .then(result => {
            const props: AppBaseProps = {
                context: { key1: "", keyVal1: null, contextType: "updateLicense" },
                title: launcherConfig.title,
                entity: Helper.createEmptyEntity(),
                metadata: result,
                dataSources: {},
                isWindow: false
            };
            showAppWithEditorSupport(UpdateLicenseApp, props);
        });
}

import { ApplicationRestartApp } from "../app/applicationRestart/applicationRestart.js";
const startApplicationRestart: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("applicationRestart")
        .then(result => {
            const entity =
                {
                    timeOut: 1,
                    enableWarning: false,
                    ...Helper.createEmptyEntity()
                } as ApplicationRestartEntity;

            const props: ApplicationRestartAppProps = {
                context: { key1: "", keyVal1: null, contextType: "applicationRestart" },
                title: launcherConfig.title,
                entity: entity,
                metadata: result,
                dataSources: {},
                isWindow: false
            };
            showAppWithEditorSupport(ApplicationRestartApp, props);
        });
}

import { AnnualVacationViewApp } from "../app/vacation/annualVacationView.js";
const startVacation: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("vacation"))
        .add<Metadata>(Helper.getMetaData("vacationEdit"))
        .promise()
        .then(result => {
            const metadata = result[0];
            const metadataVacationEdit = result[1];
            const entity = Helper.createEmptyEntity();
            entity.IsNew = false;

            const props: AnnualVacationViewAppProps = {
                data: { VacationRessProperties: [] } as any,
                context: {
                    contextType: "vacation",
                },
                title: launcherConfig.title,
                entity: entity,
                metadata: metadata,
                metadataVacationEdit: metadataVacationEdit,
                dataSources: {},
                isWindow: launcherConfig.isWindow
            };
            showAppWithEditorSupport(AnnualVacationViewApp, props);
        });
}

import { SupportZipApp } from "../app/supportZip/supportZip.js";
const startSupportZip: LauncherAction<SupportZipData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("supportZip"))
        .add<JsonResultClass<SupportZipEntity>>("SupportZip/Init")
        .promise()
        .then(result => {
            const props: SupportZipAppProps = {
                context: { key1: "", keyVal1: null, contextType: "supportZip" },
                title: launcherConfig.title,
                entity: result[1].Data,
                metadata: result[0],
                dataSources: {},
                isWindow: false,
                subTitle: launcherData.subTitle
            };
            showAppWithEditorSupport(SupportZipApp, props);
        });
}

import { TranslationsEditorApp } from "../app/translationsEditor/translationsEditor.js";
const startTranslationsEditor: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("translationsEditor")
        .then(result => {
            const entity: any = Helper.createEmptyEntity();
            entity.IsNew = false;
            entity.IsCustomTranslation = false;

            const props = {
                context: {
                    contextType: "translationsEditor",
                    baseUrl: Config.baseUrl
                },
                title: launcherConfig.title,
                entity: entity,
                metadata: result,
                isWindow: launcherConfig.isWindow
            };
            showAppWithEditorSupport(TranslationsEditorApp, props);
        });
}

import { QRReportsApp } from "../app/qrReports/qrReports.js";
const startPrintService: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("qrReports")
        .then(result => {
            const entity = Helper.createEmptyEntity();
            entity.IsNew = false;

            const props: AppBaseProps = {
                context: { key1: "", keyVal1: null, contextType: "qrReportsGrids" },
                title: launcherConfig.title,
                entity: entity,
                metadata: result,
                dataSources: {},
                isWindow: false,
            };
            showAppWithEditorSupport(QRReportsApp, props);
        });
}

import ResourcePlanningApp from "../app/resourcePlanning/resourcePlanning.js";
const startResourcePlanning: LauncherAction<ResourcePlanningData> = (launcherConfig, launcherData) => {
    const getAssignmentData = (projnr, pindex, mandant, resourceId, from, to, adrNr) => {
        if (Helper.hasValue(projnr) && Helper.hasValue(pindex)) {
            return `ResourcePlanning/Get?projnr=${getUriParameter(projnr)}&pindex=${pindex}&readOnly=${launcherData.readOnly}`;
        } else {
            return `ResourcePlanning/NewAssignment?resourceId=${getUriParameter(resourceId)}&from=${getUriParameter(from)}&to=${getUriParameter(to)}${Helper.hasValue(adrNr) ? "&adrNr=" + getUriParameter(adrNr) : ""}${Helper.hasValue(projnr) ? "&projNr=" + getUriParameter(projnr) : ""}`;
        }
    }
    HTTPService.chainBatch
        .add<JsonResultClass<ResourcePlanningEntity>>(getAssignmentData(launcherConfig.keyValue, launcherConfig.secondKeyValue, launcherData.mandant, launcherData.resourceId, launcherData.from, launcherData.to, launcherData.adrNr))
        .add<Metadata>(Helper.getMetaData("resourcePlanning"))
        .promise()
        .then(result => {
            const entity = result[0];
            let adjustMaingroupAtNewAssignment = false;
            if (Helper.hasValue(entity.AdditionalData)) {
                adjustMaingroupAtNewAssignment = entity.AdditionalData.AdjustMaingroupAtNewAssignment;
            }
            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: ResourcePlanningAppProps = {
                    context: {
                        key1: "entity.ProjNr",
                        key2: "entity.PIndex",
                        keyVal1: launcherConfig.keyValue,
                        keyVal2: launcherConfig.secondKeyValue,
                        contextType: "resourcePlanning",
                        materialGrid: null,
                        machineGrid: null
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow,
                    configData: {
                        approvalLevel: launcherData.approvalLevel,
                        geomapEnabled: launcherData.geomapEnabled,
                        pmLink: launcherData.pmLink,
                        timeZoneEnabled: launcherData.timeZoneEnabled,
                        workHours: launcherData.workHours,
                        assignmentGroupingActive: launcherData.assignmentGroupingActive,
                        copyRessourceGroupingActive: launcherData.copyRessourceGroupingActive
                    },
                    adjustMaingroupAtNewAssignment: adjustMaingroupAtNewAssignment
                };
                showAppWithEditorSupport(ResourcePlanningApp, props);
            }
        });
}

import { ServiceReportListApp } from "../app/serviceReportList/serviceReportList.js";
const startServiceReportList: LauncherAction<ServiceReportListData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("serviceReportList"))
        .add<JsonResultClass>(`ServiceReport/InitListView/?projNr=${getUriParameter(launcherConfig.keyValue)}&pIndex=${getUriParameter(launcherConfig.secondKeyValue)}`)
        .promise()
        .then(result => {
            const serviceReportList = result[1];
            const entity = Helper.createEmptyEntity() as EntityServiceReportList;
            entity.IsNew = false;
            entity.ProjNr = launcherConfig.keyValue;
            entity.PIndex = launcherConfig.secondKeyValue;
            entity.BelegNr = launcherData.belegNr;
            entity.Ursprung = launcherData.ursprung;
            entity.useThinfinityDgfUrl = launcherData.useThinfinityDgfUrl;
            if (serviceReportList.Code > 0) {
                showErrorPage(serviceReportList.Message, serviceReportList.AdditionalData);
            } else {
                const props: ServiceReportListAppProps = {
                    context: {
                        key1: "entity.ProjNr",
                        keyVal1: launcherConfig.keyValue,
                        key2: "entity.PIndex",
                        keyVal2: launcherConfig.secondKeyValue,
                        contextType: "serviceReportList",
                        serviceReportList: null,
                        serviceReportListGridOptions: null,
                        onChangeServiceReportList: null,
                        onRefresh: null
                    },
                    title: launcherConfig.title,
                    entity: entity,
                    metadata: result[0],
                    serviceReportList: serviceReportList.Data,
                    isWindow: launcherConfig.isWindow,
                    dataSources: {}
                };

                showAppWithEditorSupport(ServiceReportListApp, props);
            }
        });
}

import { ServiceReportApp } from "../app/serviceReport/serviceReport.js";
const startServiceReportEdit: LauncherAction<ServiceReportData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("serviceReport"))
        .add("ServiceReportLookup/GetZeittypen?belegnr=" + getUriParameter(launcherConfig.keyValue))
        .add("ServiceReportLookup/GetFeiertagarten")
        .add<JsonResultClass<EntityServiceReport>>(`ServiceReport/Init?projNr=${getUriParameter(launcherData.projNr)}&pIndex=${getUriParameter(launcherData.pIndex)}&id=${getUriParameter(launcherConfig.keyValue)}`)
        .add<Metadata>(Helper.getMetaData("serviceReportCompletion"))
        .add("ServiceReportLookup/GetDynZeitypen?id=" + getUriParameter(launcherData.ressNr) + "&belegnr=" + getUriParameter(launcherConfig.keyValue))
        .promise()
        .then(result => {
            const metadata = result[0];
            const zeittypen = result[1];
            const feiertagsarten = result[2];
            const entity = result[3];
            const metadataCompletion = result[4];
            const dynzeittypen = result[5];

            const doesAssignmentExists = !Helper.isNullOrEmpty(launcherData.projNr) && Helper.hasValue(launcherData.pIndex);
            if (!doesAssignmentExists) {
                NotificationHelper.showErrorMessage(Helper.getTranslation("Einsatz.EinsatzNichtGefunden"));
            }

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: ServiceReportAppProps = {
                    doesAssignmentExists: doesAssignmentExists,
                    context: {
                        key1: "entity.Belegnr",
                        keyVal1: entity.Data.Belegnr,
                        contextType: "serviceReport",
                        metadataCompletion: null,
                        references: null,
                        onHandlePostSave: null,
                        onEvalAction: null,
                        machineGrid: null,
                        emailRecipientGrid: null
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: metadata,
                    metadataCompletion: metadataCompletion,
                    dataSources: {
                        parentServiceReport: {
                            lookups: {
                                zeittypen: zeittypen,
                                feiertagarten: feiertagsarten,
                                dynzeittypen: dynzeittypen
                            }
                        },
                        dsContacts: [],
                        zeittypen: result[1],
                        dynZeittypen: result[5]
                    },
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(ServiceReportApp, props);
            }
        });
}

const startTravelReportEdit: LauncherAction = (launcherConfig, launcherData: { belegNr: number, isReadonly: boolean }) => {
    const dataURL = `TravelReportEdit/GetTravelReportVm?isReadonly=${launcherData.isReadonly ?? false}` + (Helper.hasValue(launcherData.belegNr) ? ("&belegNr=" + launcherData.belegNr) : "");
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("editTravelReport"))
        .add(dataURL)
        .promise()
        .then(result => {
            const metaData = result[0];
            const entity: TravelReportEntity = result[1].Data;
            if (result[1].Code > 0) {
                showErrorPage(result[1].Message, result[1].AdditionalData);
            } else {
                const props: EditTravelReportProps = {
                    context: { key1: "belegnr", keyVal1: launcherData.belegNr, contextType: "editTravelReport" },
                    title: launcherConfig.title,
                    isReadonly: launcherData.isReadonly,
                    entity: {
                        TravelReport: entity,
                        IsNew: false,
                        RecordRight: entity.RecordRight,
                        IsWatchable: entity.IsWatchable,
                        IsWatched: entity.IsWatched,
                        IsTemporaryEditing: false
                    },
                    metadata: metaData,
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };
                showAppWithEditorSupport(EditTravelReportApp, props);
            }
        });
}

import { TravelReportSearchApp } from "../app/travelReport/travelReportSearch.js";
const startTravelReportSearch: LauncherAction = (launcherConfig: any) => {
    const dataURL = "TravelReport/InitSearch";
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("travelReportSearch"))
        .add<JsonResultClass<TravelReportSearchEntity>>(dataURL)
        .promise()
        .then(result => {
            const jsonResult = result[1];
            if (jsonResult.Code > 0) {
                showErrorPage(jsonResult.Message, jsonResult.AdditionalData);
            } else {
                const metadata = result[0];
                const entity: TravelReportSearchEntity = jsonResult.Data;
                const props: TravelReportSearchProps = {
                    context: { key1: "entity.RessNr", keyVal1: launcherConfig.keyValue },
                    title: launcherConfig.title,
                    entity: entity,
                    metadata: metadata,
                    isWindow: launcherConfig.isWindow,
                    dataSources: null
                };
                showAppWithEditorSupport(TravelReportSearchApp, props);
            }
        });
}

import { ResourcePlanningPMApp } from "../app/resourcePlanningPM/resourcePlanningPM.js";
const startResourcePlanningPM: LauncherAction<ResourcePlanningPMData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<ResourcePlanningPMEntity>>("ResourcePlanningPM/Init?resourceId=" + getUriParameter(launcherData.resourceId) + (launcherData.from ? "&from=" + getUriParameter(launcherData.from) : "") + (launcherData.to ? "&to=" + getUriParameter(launcherData.to) : ""))
        .add<Metadata>(Helper.getMetaData("resourcePlanningPM"))
        .promise()
        .then(result => {
            const entity = result[0];
            const metadata = result[1];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: ResourcePlanningPMAppProps = {
                    context: { key1: "", keyVal1: null, contextType: "resourcePlanningPM" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: metadata,
                    dataSources: {},
                    isWindow: true,
                    resourceId: launcherData.resourceId
                };
                showAppWithEditorSupport(ResourcePlanningPMApp, props);
            }
        });
}

import CrReportMaterialApp from "../app/crReport/crReportMaterialApp.js";
const startReportMaterial: LauncherAction<ReportMachineData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("crReportMaterial"))
        .promise()
        .then(result => {
            const metadata = result[0];
            const entity: any = Helper.createEmptyEntity();
            entity.IsNew = false;
            entity.ReportAcquisition = true;
            const props = {
                context: {
                    key1: "", keyVal1: null,
                    contextType: "crReportMaterial",
                    projectNo: launcherData.projectNo,
                    pIndex: launcherData.pIndex
                },
                title: launcherConfig.title,
                entity: entity,
                metadata: metadata,
                dataSources: {},
                isWindow: true
            };
            showAppWithEditorSupport(CrReportMaterialApp, props);
            General.Drawer.Left.disable();
        });
}

import CrMachineMaterialApp from "../app/crReport/crMachineMaterialApp.js";
const startMachineMaterial: LauncherAction<ReportMachineData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("crMachineMaterial"))
        .promise()
        .then(result => {
            const metadata = result[0];
            const entity: any = Helper.createEmptyEntity();
            entity.IsNew = false;
            entity.ReportAcquisition = true;
            const props = {
                context: {
                    key1: "", keyVal1: null,
                    contextType: "crReportMaterial",
                    projectNo: launcherData.projectNo,
                    pIndex: launcherData.pIndex
                },
                title: launcherConfig.title,
                entity: entity,
                metadata: metadata,
                dataSources: {},
                isWindow: true
            };
            showAppWithEditorSupport(CrMachineMaterialApp, props);
            General.Drawer.Left.disable();
        });
}

import MonatsAbrechnungInGrid from "../app/crReport/cusNovofermMonatsAbrechnung.js";
const startNovofermMonatsAbrechnung: LauncherAction<ReportMachineData> = (launcherConfig, launcherData) => {
    const metadata = "";
    const entity: any = Helper.createEmptyEntity();
    entity.IsNew = false;
    entity.ReportAcquisition = true;
    const props = {
        context: {
            key1: "", keyVal1: null,
            contextType: "",
        },
        title: launcherConfig.title,
        entity: entity,
        metadata: metadata,
        dataSources: {},
        isWindow: false
    };
    showAppWithEditorSupport(MonatsAbrechnungInGrid, props);
    General.Drawer.Left.disable();
}

import { EditReportApp } from "../app/editReport/editReport.js";
const startReporting: LauncherAction<ReportingData> = (launcherConfig, launcherData) => {

    let getDataUrl =
        'Reporting/GetReportData?reportId=' + getUriParameter(launcherData.reportId)
        + "&type=" + launcherData.type;
    if (Helper.hasValue(launcherData.position)) {
        getDataUrl += "&serviceReportId=" + launcherData.serviceReportId
            + "&position=" + launcherData.position;
    }


    const getDescriptionUrl = Helper.hasValue(launcherData.position) ? null :
        'Reporting/GetReportStructure?reportId=' + launcherData.reportId
        + (launcherData.machine ? "&machineNumber=" + getUriParameter(launcherData.machine) : "");

    const getRightsUrl = Helper.hasValue(launcherData.position) ? null :
        'Reporting/GetReportRights?recordId=' + getUriParameter(launcherData.serviceReportId) + "&type=" + launcherData.type;


    HTTPService.chainBatch
        .add(getDataUrl)
        .add<Metadata>(Helper.getMetaData("report"))
        .add(getDescriptionUrl)
        .add(getRightsUrl)
        .promise()
        .then(result => {
            const data = result[0];
            const metadata = result[1];
            const description = result[2];
            const rights = result[3];
            const entity: any = Helper.createEmptyEntity();
            entity.serviceReportId = launcherData.serviceReportId;
            const noRights = data && data.Code > 0;
            if (launcherData.serviceReportId) {
                entity.IsNew = false;
            }
            if (noRights) {
                NotificationHelper.showErrorMessage(data.Message);
                entity.RecordRight.CanRead = false;
                entity.RecordRight.CanWrite = false;
            } else {
                entity.type = data.Data.Data.Type;
                entity.RecordRight = Helper.hasValue(launcherData.position) ? data.Data.Rights : rights.Data;
            }

            const props: EditReportAppProps = {
                context: {
                    reportId: launcherData.reportId,
                    recordId: launcherData.recordId,
                    serviceReportId: launcherData.serviceReportId,
                    position: launcherData.position,
                    type: launcherData.type,
                    machine: launcherData.machine,
                    pIndex: launcherData.pIndex,
                    contextType: "crReport",
                    keyVal1: launcherData.serviceReportId,
                    plannedReportId: launcherData.plannedReportId,
                    parentIsguid: launcherData.recordIsguid,
                    remark: launcherData.remark
                },
                title: launcherConfig.title,
                entity: entity,
                metadata: metadata,
                isWindow: launcherConfig.isWindow,
                data: data && noRights === false ? data.Data.Data : null,
                description: noRights ? null : (Helper.hasValue(launcherData.position) ? data.Data.Structure : description.Data),
                dataSources: {},
                mandant: launcherData.mandant
            };
            showAppWithEditorSupport(EditReportApp, props);
        });
}

import ResourcePlanningSchedulerApp from "../app/resourcePlanningScheduler/resourcePlanningScheduler.js";
const startResourcePlanningScheduler: LauncherAction<ResourcePlanningSchedulerData> = (launcherConfig, launcherData) => {

    const ds = Helper.loadDataFromStorage("resourcePlanningScheduler_DisplaySettings");

    let flagMode = 0;
    if (Helper.hasValue(ds) && Helper.hasValue(ds.FlagMode) && 0 <= ds.FlagMode && ds.FlagMode <= 2) {
        flagMode = ds.FlagMode;
    }
        let showProjectColor = false;
        if (Helper.hasValue(ds)) {
            showProjectColor = ds.ShowProjectColor;
        }

    let grouped = 0;
    if (Helper.hasValue(ds)) {
            const GroupByResources = Helper.hasValue(ds.GroupByResources) && ds.GroupByResources === true;
            const GroupByAddresses = Helper.hasValue(ds.GroupByAddresses) && ds.GroupByAddresses === true;
            const GroupByProjects = Helper.hasValue(ds.GroupByProjects) && ds.GroupByProjects === true;
            const GroupByMachines = Helper.hasValue(ds.GroupByMachines) && ds.GroupByMachines === true;
            if (GroupByResources || GroupByAddresses || GroupByProjects || GroupByMachines) {
                if (GroupByResources)
                    grouped = 1;
                if (GroupByAddresses)
                    grouped = 2;
                if (GroupByProjects)
                    grouped = 3;
                if (GroupByMachines)
                    grouped = 4;
        }
    }


    HTTPService.chainBatch
            .add<JsonResultClass>(`ResourcePlanningScheduler/GetInitialSettings?projNr=${getUriParameter(launcherData.projNr)}&pIndex=${getUriParameter(launcherData.pIndex)}${Helper.hasValue(launcherData.start) ? "&start=" + getUriParameter(launcherData.start) : ""}${Helper.hasValue(launcherData.onlyMarkAssignment) ? ("&onlyMarkAssignment=" + getUriParameter(launcherData.onlyMarkAssignment)) : ""}&showProjectColor=${showProjectColor}`)
            .add<JsonResultClass>(`ResourcePlanningScheduler/GetInitialData?projNr=${getUriParameter(launcherData.projNr)}&pIndex=${getUriParameter(launcherData.pIndex)}${Helper.hasValue(launcherData.start) ? "&start=" + getUriParameter(launcherData.start) : ""}&flagMode=${getUriParameter(flagMode)}&showProjectColor=${showProjectColor}&=${grouped}`)
        .add<Metadata>(Helper.getMetaData("resourcePlanningScheduler"))
        .add('ResourceLookup/GetResstypen')
        .add<JsonResultClass>("ResourcePlanningScheduler/GetLookups")
        .promise()
        .then(result => {
            const settings = result[0];
            const data = result[1];
            const metadata = result[2];
            const resstypenDS = result[3];
            const lookups = result[4].Data;

            if (settings.Code > 0) {
                NotificationHelper.showErrorMessage(settings.Message);
            } else if (data.Code > 0) {
                NotificationHelper.showErrorMessage(data.Message);
            } else {
                const props = {
                    context: { contextType: "resourcePlanningScheduler" },
                    title: launcherConfig.title,
                    metadata: metadata,
                    data: data.Data,
                    settings: settings.Data,
                    lookups: lookups,
                    dataSources: {
                        resstypenDS: resstypenDS
                    },
                };

                General.Drawer.Left.disableAnimation();
                showAppWithEditorSupport(ResourcePlanningSchedulerApp, props);
                General.Drawer.Left.enableAnimation();
            }
        });
}

import { HomeApp } from "../app/home/home.js";
const startHome: LauncherAction = async (launcherConfig) => {
    const metaData = await HomeHelper.getMetaDataForHome();
    const entity = Helper.createEmptyEntity();
    entity.IsNew = false;
    const props: AppBaseProps = {
        context: { key1: "name", keyVal1: Config.user, contextType: "home" },
        title: launcherConfig.title,
        entity: entity,
        metadata: metaData,
        dataSources: {},
        isWindow: false
    };
    General.Content.MountComponent(HomeApp, props);
}

import ShortCutInfo from "../app/help/shortCutsInfo.js";
const startShortCutHelp: LauncherAction = () => {
    Helper.getMetaData("shortCutInfo")
        .then(result => {
            const entity = Helper.createEmptyEntity();
            const props: AppBaseProps = {
                context: { contextType: "shortCutInfo" },
                dataSources: {},
                entity: entity,
                isWindow: false,
                metadata: result,
                title: "Shortcuts"
            };
            showAppWithEditorSupport(ShortCutInfo, props);
        });
}

import HomeContact from "../app/help/homeContact.js";
const startHomeContact: LauncherAction = (launcherConfig) => {
    Helper.getMetaData("homeContact")
        .then(result => {
            const entity = Helper.createEmptyEntity();
            const props: AppBaseProps = {
                context: { contextType: "homeContact" },
                dataSources: {},
                entity: entity,
                isWindow: false,
                metadata: result,
                title: launcherConfig.title
            };

            showAppWithEditorSupport(HomeContact, props);
        });
}

import { WeeklyReportListApp } from "../app/weeklyReportList/weeklyReportList";
const startWeeklyReportList: LauncherAction<WeeklyReportListData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("weeklyReportList"))
        .add(`WeeklyReport/InitListView/?ressNr=${getUriParameter(launcherConfig.keyValue)}&von=${getUriParameter(launcherData.von)}&bis=${getUriParameter(launcherData.bis)}`)
        .promise()
        .then(result => {
            const metadata = result[0];
            const weeklyReportList = result[1];
            const entity = Helper.createEmptyEntity() as EntityWeeklyReportList;
            entity.IsNew = false;
            entity.RessNr = launcherConfig.keyValue;
            entity.BelegNr = launcherData.belegNr;
            entity.Ursprung = launcherData.ursprung;
            entity.useThinfinityDgfUrl = launcherData.useThinfinityDgfUrl;
            entity.Von = launcherData.von;
            entity.Bis = launcherData.bis;
            entity.RecordRight = weeklyReportList.Data?.RecordRight;
            if (weeklyReportList.Code > 0) {
                showErrorPage(weeklyReportList.Message, weeklyReportList.AdditionalData);
            } else {
                const props: WeeklyReportListAppProps = {
                    context: { key1: "entity.RessNr", keyVal1: launcherConfig.keyValue, contextType: "weeklyReportList" },
                    title: launcherConfig.title,
                    entity: entity,
                    metadata: metadata,
                    weeklyReportList: weeklyReportList.Data,
                    isWindow: launcherConfig.isWindow,
                    dataSources: null
                };
                showAppWithEditorSupport(WeeklyReportListApp, props);
            }
        });
}

import { WeeklyReportApp } from "../app/weeklyReport/weeklyReport";
const startWeeklyReportEdit: LauncherAction<WeeklyReportData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("weeklyReport"))
        .add<JsonResultClass<EntityWeeklyReport>>(`WeeklyReport/Init?ressNr=${getUriParameter(launcherData.ressNr)}&von=${getUriParameter(launcherData.von)}&bis=${getUriParameter(launcherData.bis)}&id=${getUriParameter(launcherConfig.keyValue)}&isReadonly=${launcherData.isReadonly ?? false}`)
        .add("ServiceReportLookup/GetZeittypen")
        .add("ServiceReportLookup/GetFeiertagarten")
        .add("ServiceReportLookup/GetDynZeitypen?id=" + getUriParameter(launcherData.ressNr))
        .promise()
        .then(result => {
            const metadata = result[0];
            const entity = result[1];

            const zeittypen = result[2];
            const feiertagsarten = result[3];
            const dynzeittypen = result[4];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: WeeklyReportAppProps = {
                    context: { key1: "entity.Belegnr", keyVal1: entity.Data.Belegnr, contextType: "weeklyReport" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: metadata,
                    isWindow: launcherConfig.isWindow,
                    stdMinuten: launcherData.stdMinuten,
                    firstDayOfWeek: launcherData.firstDayOfWeek,
                    dayOfWeekSaturdayRessource: launcherData.dayOfWeekSaturdayRessource,
                    dayOfWeekSundayRessource: launcherData.dayOfWeekSundayRessource,
                    dataSources: {
                        parentServiceReport: {
                            lookups: {
                                zeittypen: zeittypen,
                                feiertagarten: feiertagsarten,
                                dynzeittypen: dynzeittypen
                            }
                        },
                        dsContacts: []
                    }
                };
                showAppWithEditorSupport(WeeklyReportApp, props);
            }
        });
}

import { DirectionsApp } from "../app/geomap/directions/directions.js";
const startDirections: LauncherAction<DirectionsData> = (launcherConfig, launcherData) => {
    const props: DirectionsAppProps = {
        context: { contextType: "directions" },
        title: "Directions",
        type: launcherData.config.Type,
        id1: launcherData.config.Id1,
        id2: launcherData.config.Id2,
        resourceIDs: launcherData.config.ResourceIds,
        groups: launcherData.config.Groups,
        sortAfterOptimisation: launcherData.config.SortAfterOptimisation,
        resourceFilterDaysBefore: launcherData.config.ResourceFilterDaysBefore,
        resourceFilterDaysAfter: launcherData.config.ResourceFilterDaysAfter,
        perimeterDaysBefore: launcherData.config.PerimeterDaysBefore,
        perimeterDaysAfter: launcherData.config.PerimeterDaysAfter,
        sliderMax: launcherData.config.SliderMax,
        sliderSmallStep: launcherData.config.SliderSmallStep,
        sliderLargeStep: launcherData.config.SliderLargeStep,
        tabId: (launcherData.config.FromPB ? "PB_" : "") + kendo.guid(),
        start: kendo.parseDate(launcherData.config.Start),
        end: kendo.parseDate(launcherData.config.End),
        pointInfo: launcherData.config.PointInfo,
        useMiles: launcherData.config.UseMiles,
        minimumClusterSize: launcherData.config.MinimumClusterSize,
        clusterGridSize: launcherData.config.ClusterGridSize,
        maxContainerSize: launcherData.config.MaxContainerSize,
        searchAlongRouteAvailable: launcherData.config.SearchAlongRouteAvailable,
        schedulerView: false
    }

    document.title = `${launcherData.title}(${props.tabId})`;
    General.Content.MountComponent(DirectionsApp, props);
}

const startError: LauncherAction<ErrorData> = (launcherConfig, launcherData) => {
    showErrorPage(launcherData.message, launcherData.additionalData);
}

import ErrorApp from "../app/error/error.js";
const showErrorPage = (message, additionalData) => {
    const props: ErrorAppProps = {
        message: message,
        additionalData: additionalData
    }
    General.Content.MountComponent(ErrorApp, props);
}

import { RemindersApp } from "../app/reminders/reminders.js";
const showReminderList = (reminderViewMode: ReminderViewMode): LauncherAction<RemindersData> => {
    return async (launcherConfig, launcherData) => {
        const [metadata, data] = await Promise.all(
            [
                Helper.getMetaData("reminders"),
                HTTPService.get('Tasks/GetAdditionalData')    
            ]
        );
        const {showAllBtn} = data;
        const entity = Helper.createEmptyEntity() as any;
        entity.IsNew = false;
        entity.ReminderMode = reminderViewMode;
        const props: RemindersListAppProps = {
            entity,
            metadata: metadata,
            isWindow: launcherConfig.isWindow,
            context: { key1: "", keyVal1: null, contextType: "remindersGrid" },
            title: launcherConfig.title,
            dataSources: {},
            url: launcherData.url,
            reminderMode: reminderViewMode,
            initalDataCondition: DataCondition.AssignedToMe,
            showAllBtn: showAllBtn
        };

        showAppWithEditorSupport(RemindersApp, props);
    }
}

const startCreatedRemindersList: LauncherAction<RemindersData> = showReminderList(ReminderViewMode.Created);
const startRemindersList: LauncherAction<RemindersData> = showReminderList(ReminderViewMode.Assigned);

const showReminderEdit = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<ReminderEntity>>('Tasks/Open?id=' + launcherData.id)
        .add<Metadata>(Helper.getMetaData("remindersQuickAdd"))
        .promise()
        .then(result => {
            if (result[0].Code != 0) {
                showErrorPage(result[0].Message, result[0].AdditionalData);
                return;
            } else {
                const reminder = result[0].Data;
                const metaData = result[1];
               
                const props: ReminderAppProps = {
                    entity: reminder,
                    metadata: metaData,
                    context: { contextType: "reminderEdit", key1: null, keyVal1: null },
                    isWindow: true,
                    operation: Operation.Edit,
                    existingReminders: [],
                    reminderId: launcherData.id,
                    handleMenuSelect: () => { },
                    enableMenuItem: () => true,
                    handleCreateValidator: null,
                    handleDataLoaded: () => { },
                    onChange: () => { },
                    handleFieldChange: () => { }
                }

                showAppWithEditorSupport(EditReminder, props);
            }
        });
}

import ServiceHoursApp from "../app/sla/serviceHours/serviceHours.js";
const startSLAServiceHours: LauncherAction<SlaServiceHoursData> = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass>('SlaServiceHours/Init/?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("slaServiceHours"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: ServiceHoursProps = {
                    context: { key1: "entity.Id", keyVal1: launcherConfig.keyValue, contextType: "slaservicehours", translations: null },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow,
                    TypesOfDay: launcherData.TypesOfDay
                };

                showAppWithEditorSupport(ServiceHoursApp, props);
            }
        });
}


import RecurringTaskApp from "../app/tasks/recurringTask/recurringTask.js";
const startRecurringTask: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<RecurringTaskEntity>>('RecurringTask/Init/?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("recurringTask"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: RecurringTaskAppProps = {
                    context: {
                        key1: "entity.Id",
                        keyVal1: launcherConfig.keyValue,
                        contextType: "recurringTask",
                        workPackageGridOptions: null,
                        machineGridOptions: null,
                        standAlone: true
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(RecurringTaskApp, props);
            }
        });
}

import TaskGroupApp from "../app/taskGroup/taskGroup.js";
const startTaskGroupCreate: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<TaskGroupNodeEditEntity>>('TaskGroup/CreateNew')
        .add<Metadata>(Helper.getMetaData("taskGroup"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: TaskGroupAppProps = {
                    context: {
                        key1: "entity.TaskGroup.ExplicitValues.Id",
                        keyVal1: launcherConfig.keyValue,
                        contextType: "taskGroup",
                        translations: null,
                        standAlone: true
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    dataSources: {},
                    metadata: result[1],
                    isWindow: launcherConfig.isWindow
                };
                showAppWithEditorSupport(TaskGroupApp, props);
            }
        });
}

const startTaskGroupEdit: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<TaskGroupNodeEditEntity>>('TaskGroup/InitRoot?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("taskGroup"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: TaskGroupAppProps = {
                    context: {
                        key1: "entity.TaskGroup.ExplicitValues.Id",
                        keyVal1: launcherConfig.keyValue,
                        contextType: "taskGroup",
                        translations: null,
                        standAlone: true
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    dataSources: {},
                    metadata: result[1],
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(TaskGroupApp, props);
            }
        });
}

import WorkPackageApp from "../app/tasks/workPackage/workPackage.js";
const startWorkPackageTemplateCreate: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<WorkPackageEntity>>("WorkPackageTemplate/Init")
        .add<Metadata>(Helper.getMetaData("WorkPackageTemplate"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: WorkPackageAppProps = {
                    readOnly: false,
                    context: {
                        key1: "entity.Id",
                        keyVal1: launcherConfig.keyValue,
                        contextType: "workPackageTemplate",
                        standAlone: true
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    dataSources: {},
                    metadata: result[1],
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(WorkPackageApp, props);
            }
        });
}

const startWorkPackageEdit = (metadataType: string): LauncherAction => {
    return (launcherConfig, launcherData) => {
        HTTPService.chainBatch
            .add<JsonResultClass<WorkPackageEntity>>(metadataType + '/Init?id=' + getUriParameter(launcherConfig.keyValue))
            .add<Metadata>(Helper.getMetaData(metadataType))
            .promise()
            .then((result) => {
                const entity = result[0];

                if (entity.Code > 0) {
                    NotificationHelper.showErrorMessage(entity.Message);
                } else {
                    const props: WorkPackageAppProps = {
                        readOnly: false,
                        context: {
                            key1: "entity.Id",
                            keyVal1: launcherConfig.keyValue,
                            contextType: metadataType,
                            standAlone: true
                        },
                        title: launcherConfig.title,
                        entity: entity.Data,
                        dataSources: {},
                        metadata: result[1],
                        isWindow: launcherConfig.isWindow
                    };

                    showAppWithEditorSupport(WorkPackageApp, props);
                }
            });
    }
}

const startAssignmentDistribution: LauncherAction = async (launcherConfig, launcherData) => {
    const results = await Promise.all([
        HTTPService.get<JsonResultClass<any>>('AssignmentDistribution/Init'),
        Helper.getMetaData("assignmentDistributionInput"),
        Helper.getMetaData("assignmentDistributionPreview")

    ]);

    const entity = results[0];

    if (entity.Code > 0) {
        NotificationHelper.showErrorMessage(entity.Message);
        return;
    }

    const props: AssignmentDistributionWizardProps = {
        inputEntity: entity.Data,
        inputMetaData: results[1],
        previewMetaData: results[2],
        dataSources: {
            strategies: results[0].AdditionalData["Strategies"]
        }
    }
    General.Content.MountComponent(AssignmentDistributionWizard, props);
}

import ExecuteAllAppLauncher from "../app/tasks/recurringTask/executeAllTasks.js";
const startExecuteAll: LauncherAction = (launcherConfig, launcherData) => {
    General.Content.MountComponent(ExecuteAllAppLauncher, { isWindow: launcherConfig.isWindow });
}

import AbsenceOverviewApp from "../app/absenceOverview/absenceOverview.js";
const startAbsenceOverview: LauncherAction = (launcherConfig, launcherData) => {
    let readOnly = launcherData["ReadOnly"];
    HTTPService.chainBatch
        .add<JsonResultClass<AbsenceOverviewEntity>>('AbsenceOverview/Init?ressNr=' + getUriParameter(launcherConfig.keyValue) + '&readOnly=' + readOnly)
        .add<Metadata>(Helper.getMetaData("absenceOverview"))
        .promise()
        .then((result) => {
            const entity = result[0];
            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: AbsenceOverviewAppProps = {
                    context: {
                        contextType: "absenceOverview"
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(AbsenceOverviewApp, props);
            }
        });
}

import ExecutionsApp from "../app/tasks/recurringTask/executions.js";
const startExecutions: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<any>>('Executions/Init')
        .add<Metadata>(Helper.getMetaData("executions"))
        .promise()
        .then((result) => {
            const entity = result[0];
            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: any = {
                    context: {
                        contextType: "executions"
                    },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(ExecutionsApp, props);
            }
        });
}

import AgreementApp from "../app/sla/agreement/agreement.js";
const startSlaAgreement: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<AgreementEntity>>('SlaAgreement/Init/?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("slaAgreement"))
        .add<JsonResultClass<ActionRight[]>>('SlaAgreement/GetRights/?id=' + getUriParameter(launcherConfig.keyValue))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: AgreementAppProps = {
                    context: { key1: "entity.Id", keyVal1: launcherConfig.keyValue, contextType: "slaagreement", translations: null },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow,
                    actionRights: result[2].Data
                };

                showAppWithEditorSupport(AgreementApp, props);
            }
        });
}

import LevelApp from "../app/sla/level/level.js";
const startSLALevel: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass>('SlaLevel/Init/?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("slaLevel"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                NotificationHelper.showErrorMessage(entity.Message);
            } else {
                const props: LevelAppProps = {
                    context: { key1: "entity.Id", keyVal1: launcherConfig.keyValue, contextType: "slalevel" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(LevelApp, props);
            }
        });
}

import PlannedReports from "../app/crReport/plannedReports.js";
const startPlannedReports: LauncherAction = (launcherConfig, launcherData) => {
    const getAssignmentData = (projnr, pindex, mandant) => {
        return `PlannedReports/Get/?projnr=${getUriParameter(projnr)}&pindex=${pindex}&mandant=${(mandant ? getUriParameter(mandant) : "")}`;
    }
    HTTPService.chainBatch
        .add<JsonResultClass<ResourcePlanningEntity>>(getAssignmentData(launcherConfig.keyValue, launcherConfig.secondKeyValue, ""))
        .add<Metadata>(Helper.getMetaData("plannedreports"))
        .promise()
        .then((result) => {
            const entity: any = result[0];
            entity.Data.ReportAcquisition = true;
            if (false) {
            } else {
                const props = {
                    context: {
                        key1: "entity.Id",
                        keyVal1: launcherConfig.keyValue,
                        keyVal2: launcherConfig.secondKeyValue,
                        contextType: "resourcePlanning"
                    },
                    title: launcherConfig.title,
                    metadata: result[1],
                    entity: entity.Data,
                    dataSources: {},
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(PlannedReports, props);
            }
        });
}

import { MigrationApp } from "../app/migration/migration.js";
const startMigartion: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("migration"))
        .promise()
        .then((result) => {
            const props = {
                context: {
                    key1: "entity.Id",
                    keyVal1: launcherConfig.keyValue,
                    keyVal2: launcherConfig.secondKeyValue,
                    contextType: "resourcePlanning"
                },
                title: launcherConfig.title,
                metadata: result[0],
                entity: {
                    IsNew: false,
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true
                    }
                },
                dataSources: {},
                isWindow: launcherConfig.isWindow
            };

            showAppWithEditorSupport(MigrationApp, props);
        });
}

import *  as statisticui from "../app/statistics/statistic_ui.js";
const startStatistic: LauncherAction = (launcherConfig, launcherData) => {
    statisticui.registerComponents();
    General.Content.MountComponent(statisticui.DrillDownStatisticViewer, { location: {}, match: { params: { statisticId: launcherConfig.keyValue } } });
}

import { StatisticUiList } from "../app/statistics/uieditor/ui_editor_list.js";
const startUiBuilderList: LauncherAction = (launcherConfig, launcherData) => {

    new SettingsController().GetSettings((result: any) => {
        const s = getGlobalSettings();
        s.SetSettings(result);
        General.Content.MountComponent(StatisticUiList, { location: {}, match: { params: { statisticId: launcherConfig.keyValue } } });
    });
}

import * as ui_editor_detail from "../app/statistics/uieditor/ui_editor_detail.js";
const startUiBuilderListDetail: LauncherAction = (launcherConfig, launcherData) => {
    ui_editor_detail.registerComponents();
    new SettingsController().GetSettings((result: any) => {
        const s = getGlobalSettings();
        s.SetSettings(result);
        General.Content.MountComponent(ui_editor_detail.UiEditor, { location: {}, match: { params: { statisticId: launcherConfig.keyValue } } });
    });
}

import * as api_builder_list from "../app/statistics/apibuilder/api_builder_list.js";
const startApiBuilder: LauncherAction = (launcherConfig, launcherData) => {

    api_builder_list.registerComponents();
    new SettingsController().GetSettings((result: any) => {
        const s = getGlobalSettings();
        s.SetSettings(result);
        General.Content.MountComponent(api_builder_list.ApiBuilderList, { location: {}, match: { params: { api: launcherConfig.keyValue } } });
    });
}

import * as api_builder from "../app/statistics/apibuilder/api_builder.js";
const startApiBuilderDetail: LauncherAction = (launcherConfig, launcherData) => {
    api_builder.registerComponents();
    new SettingsController().GetSettings((result: any) => {
        const s = getGlobalSettings();
        s.SetSettings(result);
        General.Content.MountComponent(api_builder.ApiBuilder, { location: {}, match: { params: { api: launcherConfig.keyValue } } });
    });
}

import { UserAdmin } from "../app/statistics/userAdmin/user_admin.js";
const startStatisticPermissions: LauncherAction = (launcherConfig, launcherData) => {
    new SettingsController().GetSettings((result: any) => {
        const s = getGlobalSettings();
        s.SetSettings(result);
        General.Content.MountComponent(UserAdmin, { location: {}, match: { params: { api: launcherConfig.keyValue } } });
    });
}

const startCalendarScheduler: LauncherAction = (launcherConfig, launcherData) => {
    import("../app/resourceCalendar/resourceCalendar.js").then(response => {
        General.Content.MountComponent(response.ResourceCalendar, { location: {}, match: { params: { api: launcherConfig.keyValue } } });
    }, rejected => {
        onImportRejected(rejected, "Statistic");
    });
}

import PriceListApp from "../app/priceList/priceList.js";
const startPriceList: LauncherAction = (launcherConfig, launcherData) => {
    let url: string = "PriceList/Init";
    if (launcherConfig.action == "Edit") {
        url += ("?id=" + launcherConfig.keyValue);
    }
    HTTPService.chainBatch
        .add<JsonResultClass<Entity>>(url)
        .add<Metadata>(Helper.getMetaData("priceList"))
        .add<JsonResultClass<{ Currency: string, Name: string }[]>>("Currency/GetAll")
        .add<{ Key: number, Value: string }[]>("CommercialDocumentNGLookup/GetGroups")
        .promise()
        .then((result) => {

            let entity: Entity = result[0].Data;
            entity.RecordRight = {
                CanRead: true,
                CanWrite: true
            };
            let currencies: { value: string, text: string }[] = [];
            if (result[2].Code == 0) {
                let rawData = result[2].Data.map((item: { Currency: string, Name: string }) => {
                    return {
                        value: item.Currency,
                        text: item.Name
                    };
                });
                rawData.forEach((item) => {
                    if (currencies.find(f => f.value === item.value) == undefined) {
                        currencies.push(item);
                    }
                })
            }
            let groups = result[3].map((item) => {
                return {
                    value: item.Key,
                    text: item.Value
                };
            })
            const props = {
                context: {
                    key1: "entity.Id",
                    keyVal1: launcherConfig.keyValue,
                    keyVal2: launcherConfig.secondKeyValue,
                    contextType: "priceList",
                    currencies: currencies,
                    groups: groups
                },
                title: launcherConfig.title,
                metadata: result[1],
                entity: entity,
                dataSources: {},
                isWindow: launcherConfig.isWindow
            };

            showAppWithEditorSupport(PriceListApp, props);
        });
}

import EditIndividualFieldsApp from "../app/editIndividualFields/editIndividualFields.js"
const startEditIndividualFields: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<Metadata>(Helper.getMetaData("editIndividualFields"))
        .add<JsonResultClass<boolean>>("EditIndividualFields/AreCategoriesUsed")
        .promise()
        .then((result) => {
            const entity: Entity = {
                IsNew: false,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IndividualFields: null
            }
            const props = {
                context: {
                    key1: "entity.Id",
                    keyVal1: launcherConfig.keyValue,
                    keyVal2: launcherConfig.secondKeyValue,
                    contextType: "editIndividualFields",
                    translations: null
                },
                title: launcherConfig.title,
                metadata: result[0],
                entity: entity,
                dataSources: {},
                isWindow: launcherConfig.isWindow,
                areCategoriesUsed: result[1].Data
            };

            showAppWithEditorSupport(EditIndividualFieldsApp, props);
        });
}

import ReportMetaData from "../app/reportMetaData/reportMetaData.js";
const startReportMetaData: LauncherAction = async (launcherConfig, launcherData) => {
    let url = "ReportMetaData/Init";
    let urlModified: boolean = false;
    if (Helper.hasValue(launcherConfig.keyValue)) {
        url += "?id=" + launcherConfig.keyValue;
        urlModified = true;
    }
    if (Helper.hasValue(launcherData["templateId"])) {
        if (urlModified) {
            url += "&templateId=" + launcherData["templateId"];
        } else {
            url += "?templateId=" + launcherData["templateId"];
        }
    }

    const results = await Promise.all([
        HTTPService.get<JsonResultClass<ReportDefinition>>(url),
        Helper.getMetaData("reportMetaData")
    ]);

    let entity = results[0].Data;
    if (launcherConfig.action === "Clone") {
        entity.Id = null;
        entity.IsNew = true;
        entity.IsDraft = true;
        entity.State = null;
        entity.RecordRight = {
            CanRead: true,
            CanWrite: true
        }
    }
    let data: {
        targetCodes?,
        targetTemplateIds?,
        targetTags?
    } = {};
    const dict = results[0].AdditionalData;
    if (Helper.hasValue(dict)) {
        data.targetCodes = dict["targetCodes"];
        data.targetTemplateIds = dict["targetTemplateIds"];
    }
    const props: ReportMetaDataProps = {
        context: {
            data: data,
            disableEntityType: launcherData["disableEntityType"],
            readOnly: Helper.getValueOrDefault(launcherData["readOnly"], false),
            sourceId: (launcherConfig.action === "Clone") ? launcherConfig.keyValue : null,
            templateId: dict["templateId"],
            qrParameters: results[0].AdditionalData["qrParameters"],
            contextType: "reportMetaData"
        },
        title: launcherConfig.title,
        metadata: results[1],
        entity: results[0].Data,
        dataSources: {},
        isWindow: launcherConfig.isWindow
    };

    showAppWithEditorSupport(ReportMetaData, props);
}

import ReportSearch from "../app/reportMetaData/reportSearch.js";
const reportSearch: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("reportSearch").then(metaData => {
        const entity: Entity = {
            IsNew: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            IsWatchable: false,
            IsWatched: false,
            IndividualFields: null
        }
        const props = {
            context: {
            },
            title: launcherConfig.title,
            metadata: metaData,
            entity: entity,
            dataSources: {},
            isWindow: launcherConfig.isWindow
        };
        showAppWithEditorSupport(ReportSearch, props);
    });
}

import PrintJobs from "../app/reportMetaData/printJobs.js";
const printJobs: LauncherAction = (launcherConfig, launcherData) => {
    let metaData: Metadata = {
        tabs: [
            {
                title: "",
                iconName: "",
                component: "getGrid()",
                visible: true
            }
        ],
        additional: {
            objects: [
            ]
        },
        pageTitle: Helper.getTranslation("WebSMS.Jobs")
    }
    const entity: Entity = {
        IsNew: false,
        RecordRight: {
            CanRead: true,
            CanWrite: true
        },
        IsWatchable: false,
        IsWatched: false,
        IndividualFields: null
    }
    const props: PrintJobsProps = {
        context: {
        },
        title: launcherConfig.title,
        metadata: metaData,
        entity: entity,
        dataSources: {},
        isWindow: launcherConfig.isWindow,
        historyRange: launcherData["historyRange"]
    };
    showAppWithEditorSupport(PrintJobs, props);
}

import StyleApp from "../app/style/style.js";
const startStyle: LauncherAction = async (launcherConfig, launcherData) => {
    const metaData = await Helper.getMetaData("style")
    const props: StyleAppProps = {
        context: {
            contextType: "style",
        },
        dataSources: null,
        entity: {
            IsNew: false,
            IsWatchable: false,
            IsWatched: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            }
        },
        isWindow: false,
        metadata: metaData,
        title: "Style"
    }
    General.Content.MountComponent(StyleApp, props);

}

import NukreisSelection from "../app/nukreis/nukreisSelection.js"
const startNuKreis: LauncherAction = async (launcherConfig, launcherData) => {
    const metaData = await Helper.getMetaData("nukreisSelection");
    const props: NukreisSelectionProps = {
        title: launcherConfig.title,
        context: {
            contextType: "nukreis"
        },
        entity: {
            IsNew: false,
            IsWatchable: false,
            IsWatched: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            }
        },
        isWindow: true,
        metadata: metaData,
        dataSources: null,
        mainGroupDependent: launcherData["mainGroupDependent"],
        data: launcherData["data"]
    }
    showAppWithEditorSupport(NukreisSelection, props);
}

const startCreateMultipleAssignments: LauncherAction = async (launcherConfig, launcherData) => {

    const results = await Promise.all([
        Helper.getMetaData("createMultipleAssignments"),
        Helper.getTranslations([
            "Einsatz.SaUndSo", "Einsatz.Frei", "Einsatz.Sa", "Einsatz.So", "Einsatz.MultipleCreation.Repetition", "WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.MinStart",
            "Field.Einsatz.endeist", "WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.SlotTableUntil", "WebCRM.Tasks.RecurringTaskHistory.Startdate", "Einsatz.MultipleCreation.Duration",
            "Einsatz.MultipleCreation.StartTime", "Einsatz.MultipleCreation.RepeatAll", "Field.Enum.PeriodUnits.Months", "Field.Enum.PeriodUnits.Weeks", "Field.Enum.PeriodUnits.Days",
            "Einsatz.MultipleCreation.StartOn", "Einsatz.MultipleCreation.OnDay", "Einsatz.MultipleCreation.At", "Einsatz.MultipleCreation.Position.First", "Einsatz.MultipleCreation.Position.Second",
            "Einsatz.MultipleCreation.Position.Third", "Einsatz.MultipleCreation.Position.Fourth", "Einsatz.MultipleCreation.Position.Last",
            "Einsatz.MultipleCreation.DayOfWeek.Friday", "Einsatz.MultipleCreation.DayOfWeek.Monday", "Einsatz.MultipleCreation.DayOfWeek.Saturday",
            "Einsatz.MultipleCreation.DayOfWeek.Sunday", "Einsatz.MultipleCreation.DayOfWeek.Thursday", "Einsatz.MultipleCreation.DayOfWeek.Tuesday",
            "Einsatz.MultipleCreation.DayOfWeek.Wednesday", "GeoMap.Container", "Field.Material.anzahl", "Einsatz.MultipleCreation.NoContainers",
            "Field.BelegZeit.zvon", "Field.BelegZeit.zbis"
        ])
    ]);

    const hasDispatchLicence = launcherData["hasDispatchLicence"];
    const hasMobileLicence = launcherData["hasMobileLicence"];

    let ressources = [];
    if (hasMobileLicence) {
        ressources.push({
            Name: Config.user.userName,
            Value: Config.user.ressNr
        });
    }
    const translations = results[1].Data;
    const props: CreateMultipleAssignmentsProps = {
        hasDispatchLicence: hasDispatchLicence,
        hasMobileLicence: hasMobileLicence,
        context: {
            translations: translations,
            start: Helper.dates.toDate(launcherData["start"]),
            end: Helper.dates.toDate(launcherData["end"]),
            weekendSchemas: launcherData["weekendSchemas"],
            duration: launcherData["duration"],
        },
        isWindow: true,
        metadata: results[0],
        title: "",
        dataSources: {
            codes: launcherData["codes"],
            weekEndWork: [
                { Key: 0, Value: translations["Einsatz.Frei"] },
                { Key: 1, Value: translations["Einsatz.SaUndSo"] },
                { Key: 2, Value: translations["Einsatz.Sa"] },
                { Key: 3, Value: translations["Einsatz.So"] }
            ],
            repetitions: launcherData["repetitions"],
            containers: launcherData["containers"]
        },
        entity: {
            AdrNr: launcherData["adrNr"],
            Code: launcherData["code"],
            Description: "",
            FixEnd: false,
            FixStart: false,
            IsNew: true,
            ProjNr: launcherData["projNr"],
            IsWatchable: false,
            IsWatched: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            RepetitionInfo: null,
            Title: "",
            WeekEndWork: 0,
            IndividualFields: {},
            Ressources: ressources,
            Containers: [],
            GroupId: null,
            FlagId: launcherData["flagId"]
        }
    }
    General.Content.MountComponent(CreateMultipleAssignments, props);
}


const startEditFlag: LauncherAction = async (launcherConfig, launcherData) => {
    const id = launcherConfig["keyValue"];
    const results = await Promise.all([
        Helper.getMetaData('planningBoardFlag'),
        HTTPService.get<JsonResultClass>(Helper.isNullOrEmpty(id) ? "PlanningBoardFlag/Create" : `PlanningBoardFlag/GetById?id=${id}`)
    ]);
    if (results[1].Code == 0) {
        const props: FlagProps = {
            context: {
                contextType: "editFlag"
            },
            dataSources: {},
            entity: results[1].Data,
            metadata: results[0],
            isWindow: true,
            title: "",
            closeAfterSave: launcherData["closeAfterSave"]
        }
        showAppWithEditorSupport(EditFlag, props);
    } else {
        NotificationHelper.showErrorMessage(results[1].Message)
    }
}

const startEditIcon: LauncherAction = async (launcherConfig, launcherData) => {
    const id = launcherConfig["keyValue"];
    const results = await Promise.all([
        Helper.getMetaData('planningBoardIcon'),
        HTTPService.get<JsonResultClass>(Helper.isNullOrEmpty(id) ? "Icon/Create" : `Icon/GetById?id=${id}`)
    ]);
    if (results[1].Code == 0) {
        const props: IconProps = {
            context: {
                contextType: "editIcon"
            },
            dataSources: {},
            entity: results[1].Data,
            metadata: results[0],
            isWindow: true,
            title: "",
            closeAfterSave: launcherData["closeAfterSave"]
        }
        showAppWithEditorSupport(EditIcon, props);
    } else {
        NotificationHelper.showErrorMessage(results[1].Message)
    }
}

const startShowDocuments: LauncherAction = (launcherConfig, launcherData) => {

    const props: DocumentsListAppProps = {
        entity: Helper.createEmptyEntity(),
        context: {
            contextType: "",
            keyVal1: launcherData["pk1"],
            keyVal2: launcherData["pk2"],
            key1: "",
            key2: ""
        },
        type: launcherData["type"],
        selectMode: false,
        enableAddLink: false
    }
    if (launcherData["openReadonly"]) {
        props.entity.RecordRight.CanWrite = false;
    }
    General.Content.MountComponent(DocumentsListApp, props);
}

const startInfoToolJob: LauncherAction = async (_, launcherData) => {
    const [metadata] = await Promise.all([Helper.getMetaData("infoToolJob")]);
    const entity = launcherData["model"];

    const props: InfoToolJobProps = {
        context: {},
        dataSources: {
            frequenzTyp: [
                {
                    name: Helper.getTranslation("Field.BelegAusgeführteArbeiten.minuten"),
                    value: 0
                },
                {
                    name: Helper.getTranslation("Field.BelegAusgeführteArbeiten.stunden"),
                    value: 1
                },
                {
                    name: Helper.getTranslation("Field.Enum.PeriodUnits.Days"),
                    value: 2
                }
            ],
            reactionTypes: launcherData["reactionTypes"]
        },
        entity: entity,
        isWindow: true,
        metadata: metadata,
        title: entity.Name
    };
    showAppWithEditorSupport(InfoToolJob, props);
}

const startSmartSearch = () => {
    startContextLess();
}

const startChatGptPdfPreview: LauncherAction = (launcherConfig, launcherData) => {
    General.Content.MountComponent(SemanticSearchApp, { documentId: launcherData["documentId"], chatGptEnabled: launcherData["chatGptEnabled"] });
}

const startShowDocumentation: LauncherAction = (launcherConfig, launcherData) => {
    General.Content.MountComponent(Documentation, launcherData["DokuProps"]);
}

const startAdminInfo: LauncherAction = (launcherConfig, launcherData) => {
    console.log(launcherConfig, launcherData)
    General.Content.MountComponent(AdminInfo, launcherData["SystemProps"]);
}

const startChangeNotice: LauncherAction = (launcherConfig, launcherData) => {
    Helper.getMetaData("changeNotice")
        .then(result => {
            const props = {
                LastMinutes: 5,
                context: { key1: "", keyVal1: null, contextType: "changeNotice" },
                title: launcherConfig.title,
                entity: Helper.createEmptyEntity(),
                metadata: result,
                dataSources: {},
                isWindow: false,
            };
            showAppWithEditorSupport(ChangeNoticeApp, props);
        });
}


const startInnoBot: LauncherAction = async (_, launcherData) => {
    const entity = launcherData["Entity"];
    const metaData = await Helper.getMetaData("innoBot");
    const defaultLocation = launcherData["DefaultLocation"];
    const minVersion = launcherData["MinVersion"];
    const connectionString = launcherData["ConnectionString"];


    const props: InnoBotProps = {
        entity: entity,
        context: {
            defaultLocation: defaultLocation
        },
        dataSources: {},
        isWindow: false,
        metadata: metaData,
        title: "",
        connectionString: connectionString,
        minVersion: minVersion
    };
    General.Content.MountComponent(InnoBot, props);
}

const startBookmark: LauncherAction = (launcherConfig, launcherData) => {
    var categories = launcherData["categories"];
    const props = {
        categories
    }
    General.Content.MountComponent(EditBookmarks, props);
}

const startWarehouse: LauncherAction = async (launcherConfig, launcherData) => {
    const warehouse = launcherData["warehouse"];
    const [metaData, states] = await Promise.all([
        Helper.getMetaData("warehouse"),
        StocksService.getTypes(7)
    ]);
    const props: WarehouseAppProps = {
        context: {
            storageSpaceStates: states
        },
        dataSources: {},
        entity: warehouse,
        isWindow: false,
        metadata: metaData,
        title: "Warehouse"
    };
    General.Content.MountComponent(WarehouseApp, props);
}

const startStock: LauncherAction = async (launcherConfig, launcherData) => {

    const [metadata, stockTypes, incomingGoodsMetadata, sourceTypes] = await Promise.all([
        Helper.getMetaData("stocks"),
        StocksService.getTypes(8),
        Helper.getMetaData("incomingGoods"),
        StocksService.getTypes(1)
    ]);
    const warehouses = launcherData["warehouses"] as Warehouse[];

    let storaceSpaces;
    if(warehouses && warehouses.length > 0){
        const tmp = warehouses.map(w => w.StorageSpaces).reduce((a, b) => {
            return a.concat(b);
        })
        storaceSpaces = Object.assign({}, ...tmp.map((x) => ({ [x.Id]: x.Name })));
    }
    
    const props: StocksProps = {
        warehouses: warehouses,
        context: {
            stockTypes: stockTypes,
            sourceTypes: sourceTypes,
            storaceSpaces: storaceSpaces,
            warehouses: warehouses
        },
        dataSources: {},
        entity: {
            IsNew: false,
            IsWatchable: false,
            IsWatched: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            IndividualFields: {}
        },
        isWindow: false,
        metadata: metadata,
        incomingGoodsMetadata: incomingGoodsMetadata
    }

    General.Content.MountComponent(Stocks, props);
}

import IntegrationProtocol from "../app/integrationProtocol/integrationProtocol.js";

import {EditReminder, Operation, ReminderAppProps, ReminderEntity} from "../app/remindersEdit/edit.js";

const startIntegrationProtocol: LauncherAction = (launcherConfig, launcherData) => {
    HTTPService.chainBatch
        .add<JsonResultClass<EntityIntegrationProtocol>>('IntegrationProtocol/GetLog/?id=' + getUriParameter(launcherConfig.keyValue))
        .add<Metadata>(Helper.getMetaData("integrationProtocol"))
        .promise()
        .then((result) => {
            const entity = result[0];

            if (entity.Code > 0) {
                showErrorPage(entity.Message, entity.AdditionalData);
            } else {
                const props: IntegrationProtocolProps = {
                    context: { key1: "entity.ID", keyVal1: launcherConfig.keyValue, contextType: "integrationProtocol" },
                    title: launcherConfig.title,
                    entity: entity.Data,
                    metadata: result[1],
                    dataSources: {
                        level: [
                            {
                                name: "Fatal(0)",
                                value: 0
                            },
                            {
                                name: "Error(1)",
                                value: 1
                            },
                            {
                                name: "Warning(2)",
                                value: 2
                            },
                            {
                                name: "Information(3)",
                                value: 3
                            },
                            {
                                name: "Debug(4)",
                                value: 4
                            },
                            {
                                name: "Trace(5)",
                                value: 5
                            },
                        ]
                    },
                    isWindow: launcherConfig.isWindow
                };

                showAppWithEditorSupport(IntegrationProtocol, props);
            }
        });
}

///////////////////
/// H E L P E R ///
///////////////////


const onImportRejected = (rejectd, module) => {
    throw new Error(`Error loading module: '${module}'. Reason: ${rejectd}.`);
}

const getUriParameter = (param: any) => {
    if (Helper.hasValue(param)) {
        return encodeURIComponent(param);
    } else {
        return "";
    }
}

const launchByTargetAppName: LauncherAction<any, boolean> = (launcherConfig, launcherData) => {
    if (Helper.hasValue(launcherConfig.targetApp) && launcherConfig.targetApp.trim() !== "") {
        let action: LauncherAction = null;

        switch (launcherConfig.targetApp) {
            case "error":
                action = startError;
                break;
            default:
                break;
        }

        if (action) {
            action(launcherConfig, launcherData);
            return true;
        }
        else
            return false;
    } else {
        return false;
    }
}

const launchByControllerAndAction: LauncherAction<any, boolean> = (launcherConfig, launcherData) => {
    const caPair = `${launcherConfig.controller}-${launcherConfig.action}`.toLowerCase();
    let action: LauncherAction = null;
    switch (caPair) {
        case "address-new":
        case "address-edit":
            action = startAddress;
            break;
        case "dynamicsearch-index":
        case "dynamicsearch-window":
            action = startDynamicSearch;
            break;
        case "emailsender-new":
        case "emailsender-show":
        case "emailsender-forward":
            action = startEmailSender;
            break;
        case "emailsender-history":
            action = startEmailHistory;
            break;
        case "emailsender-edittemplate":
        case "emailsender-newtemplate":
            action = startEmailTemplateEdit;
            break;
        case "emailsender-listtemplates":
            action = startEmailTemplatesList;
            break;
        case "emailsender-editdatasource":
        case "emailsender-newdatasource":
        case "emailsender-editdatasourcebyname":
            action = startEmailDataSourceEdit;
            break;
        case "emailsender-listdatasources":
            action = startEmailDataSourcesList;
            break;
        case "account-password":
            action = startChangePassword;
            break;
        case "cockpit-indexaddress":
        case "cockpit-indexmachine":
        case "cockpit-indexcontact":
            action = startCockpit;
            break;
        case "commercialdocumentng-new":
        case "commercialdocumentng-edit":
            action = startCommercialDocument;
            break;
        case "contact-new":
        case "contact-edit":
            action = startContact;
            break;
        case "admin-index":
            action = startAdmin;
            break;
        case "generalsettings-edit":
            action = startGeneralSettings;
            break;
        case "locks-index":
            action = startLocks;
            break;
        case "actionlocks-index":
            action = startActionLocks;
            break;
        case "actionlocks-editactionlocks":
        case "actionlocks-newactionlocks":
            action = startActionLocksEdit;
            break;
        case "actionlocks-editactionlocksrights":
        case "actionlocks-newactionlocksrights":
            action = startActionLocksRightsEdit;
            break;
        case "machine-edit":
        case "machine-new":
            action = startMachine;
            break;
        case "procedure-edit":
        case "procedure-new":
        case "procedure-read":
        case "procedure-editbyguid":
            action = startTicket;
            break;
        case "customapp-index":
            action = startCustomApp;
            break;
        case "project-edit":
        case "project-editbyguid":
        case "project-new":
            action = startProject;
            break;
        case "projectmanagementtimes-edit":
            action = startProjectmanagementTimes;
            break;
        case "resource-new":
        case "resource-edit":
            action = startResource;
            break;
        case "usersettings-edit":
            action = startUserOrRoleSettings("userSettings");
            break;
        case "usersettings-editrole":
            action = startUserOrRoleSettings("roleSettings");
            break;
        case "serverprotokoll-show":
            action = startServerprotokoll;
            break;
        case "serverjob-new":
        case "serverjob-edit":
            action = startServerJob;
            break;
        case "vacationplanning-new":
            action = startVacationPlanning;
            break;
        case "servertemplate-show":
            action = startServerTemplateExecute;
            break;
        case "servertemplate-edit":
            action = startServerTemplateEdit;
            break;
        case "servertemplate-new":
            action = startServerTemplateNew;
            break;
        case "updateapplication-index":
            action = startUpdateApplication;
            break;
        case "updatelicense-index":
            action = startUpdateLicense;
            break;
        case "vacation-index":
            action = startVacation;
            break;
        case "supportzip-index":
            action = startSupportZip;
            break;
        case "translationseditor-index":
            action = startTranslationsEditor;
            break;
        case "parts-edit":
        case "parts-new":
            action = startParts;
            break;
        case "printservice-index":
            action = startPrintService;
            break;
        case "resourceplanning-edit":
        case "resourceplanning-editbyguid":
            action = startResourcePlanning;
            break;
        case "servicereport-index":
        case "servicereport-openservicereport":
            action = startServiceReportList;
            break;
        case "servicereport-edit":
        case "servicereport-new":
            action = startServiceReportEdit;
            break;
        case "travelreport-new":
        case "travelreport-edit":
            action = startTravelReportEdit;
            break;
        case "travelreport-index":
            action = startTravelReportSearch;
            break;
        case "resourceplanningpm-index":
            action = startResourcePlanningPM;
            break;
        case "reporting-edit":
        case "reporting-openedit":
            action = startReporting;
            break;
        case "reporting-openreportmaterial":
            action = startReportMaterial;
            break;
        case "reporting-openmachinematerial":
            action = startMachineMaterial;
            break;
        case "reporting-cusnovofermopenmonatsabrechnung":
            action = startNovofermMonatsAbrechnung;
            break;
        case "resourceplanningscheduler-index":
            action = startResourcePlanningScheduler;
            break;
        case "home-index":
            action = startHome;
            break;
        case "weeklyreport-index":
        case "weeklyreport-openweeklyreport":
            action = startWeeklyReportList;
            break;
        case "weeklyreport-edit":
        case "weeklyreport-new":
            action = startWeeklyReportEdit;
            break;
        case "directions-index":
        case "directions-addpointinternal":
            action = startDirections;
            break;
        case "crtemplate-new":
        case "crtemplate-edit":
            action = startCRTemplate;
            break;
        case "crtemplate-importexport":
            action = startCRTemplateList;
            break;
        case "crquestion-new":
        case "crquestion-edit":
            action = startCRQuestion;
            break;
        case "tasks-index":
            action = startRemindersList;
            break;
        case "tasks-listcreated":
            action = startCreatedRemindersList;
            break;
        case "tasks-edit":
            action = showReminderEdit;
            break;
        case "slaservicehours-new":
        case "slaservicehours-edit":
            action = startSLAServiceHours;
            break;
        case "slalevel-new":
        case "slalevel-edit":
            action = startSLALevel;
            break;
        case "slaagreement-new":
        case "slaagreement-edit":
            action = startSlaAgreement;
            break;
        case "triggerexecution-executeall":
            action = startExecuteAll;
            break;
        case "assignmentdistribution-index":
            action = startAssignmentDistribution;
            break;
        case "absenceoverview-show":
            action = startAbsenceOverview;
            break;
        case "executions-show":
            action = startExecutions;
            break;
        case "recurringtask-new":
        case "recurringtask-edit":
            action = startRecurringTask;
            break;
        case "taskgroup-new":
            action = startTaskGroupCreate
            break;
        case "taskgroup-edit":
            action = startTaskGroupEdit;
            break;
        case "workpackage-edit":
            action = startWorkPackageEdit("workPackage");
            break;
        case "workpackagetemplate-new":
            action = startWorkPackageTemplateCreate;
            break;
        case "workpackagetemplate-edit":
            action = startWorkPackageEdit("workPackageTemplate");
            break;
        case "home-shortcut":
            action = startShortCutHelp;
            break;
        case "home-contact":
            action = startHomeContact;
            break;
        case "plannedreports-show":
            action = startPlannedReports;
            break;
        case "database-migration":
            action = startMigartion;
            break;
        case "statistic-shownoiframe":
        case "customstatistic-shownoiframe":
            action = startStatistic;
            break;
        case "statistic-uibuilder":
        case "customstatistic-uibuilder":
            action = startUiBuilderList;
            break;
        case "statistic-uibuilderdetail":
        case "customstatistic-uibuilderdetail":
            action = startUiBuilderListDetail;
            break;
        case "statistic-apibuilder":
        case "customstatistic-apibuilder":
            action = startApiBuilder;
            break;
        case "statistic-apibuilderdetail":
        case "customstatistic-apibuilderdetail":
            action = startApiBuilderDetail;
            break;
        case "statistic-statisticpermissions":
        case "customstatistic-statisticpermissions":
            action = startStatisticPermissions;
            break;
        case "calendarscheduler-index":
            action = startCalendarScheduler;
            break;
        case "attendanceclock-index":
            action = startAttendanceClock;
            break;
        case "flextime-index":
            action = startFlexTime;
            break;
        case "pricelist-edit":
        case "pricelist-new":
            action = startPriceList;
            break;
        case "editindividualfields-index":
            action = startEditIndividualFields;
            break;
        case "reportmetadata-new":
        case "reportmetadata-edit":
        case "reportmetadata-clone":
            action = startReportMetaData;
            break;
        case "reportmetadata-searchreport":
            action = reportSearch;
            break;
        case "atlasqrreportprint-index":
            action = printJobs;
            break;
        case "resourceplanning-resourceplanninggroupinglist":
        case "resourceplanning-resourceplanninggroupingmove":
            action = startResourcePlanningGrouping;
            break;
        case "style-index":
            action = startStyle;
            break;
        case "nukreis-index":
            action = startNuKreis;
            break;
        case "createmultipleassignments-index":
            action = startCreateMultipleAssignments;
            break;
        case "planningboardflag-edit":
            action = startEditFlag;
            break;
        case "icon-edit":
            action = startEditIcon;
            break;
        case "geocode-index":
            action = startGoocodeData;
            break;
        case "document-showdocuments":
            action = startShowDocuments;
            break;
        case "logassignments-index":
            action = startChangeNotice;
            break;
        case "help-show":
            action = startShowDocumentation;
            break;
        case "help-admin":
            action = startAdminInfo;
            break;
        case "smartsearch-init":
            action = startSmartSearch;
            break;
        case "innobot-index":
            action = startInnoBot;
            break;
        case "infotooljob-edit":
        case "infotooljob-new":
            action = startInfoToolJob;
            break;
        case "applicationrestart-index":
            action = startApplicationRestart;
            break;
        case "integrationprotocol-show":
            action = startIntegrationProtocol;
            break;
        case "bookmark-index":
            action = startBookmark;
            break;
        case "semanticsearch-index":
            action = startChatGptPdfPreview;
            break;
        case "warehouse-edit":
        case "warehouse-new":
            action = startWarehouse;
            break;
        case "stock-index":
            action = startStock;
            break;
        default:
            break;
    }
    if (action) {
        action(launcherConfig, launcherData);
        return true;
    } else {
        return false;
    }
}

const appLauncher: LauncherAction = (launcherConfig, launcherData) => {
    let appFound = launchByTargetAppName(launcherConfig, launcherData);
    if (!appFound) {
        appFound = launchByControllerAndAction(launcherConfig, launcherData);
    }
    if (!appFound) {
        let appName = launcherConfig.targetApp;
        if (!Helper.hasValue(appName)) {
            appName = launcherConfig.controller + "/" + launcherConfig.action;
        }
        NotificationHelper.showErrorMessage(`Unknown app: '${appName}'.`);
    }
}

//Actions
interface LauncherConfig {
    controller: string;
    action: string;
    targetApp?: string;
    title: string;
    isWindow: boolean;
    keyName: string;
    keyValue: any;
    secondKeyName?: string;
    secondKeyValue?: any;
}

interface LauncherAction<T = {}, R = void> {
    (launcherConfig: LauncherConfig, launcherData: T): R;
}

//Data
interface DynamicSearchData {
    searchType: string;
    displayPattern: string;
    queryParameters: StringKeyDictionary<string>;
    customParameters: null;
    newParameters: StringKeyDictionary<string>;
    quick: string;
    isMulti: boolean;
    fullObject: boolean;
    iFrame: boolean;
    withSkills: boolean;
    skillsTranslations: {
        skillProfile: string;
        matrix: string;
        general: string;
    };
    skillProfileId: string;
}

interface EmailSenderData {
    id: number;
    type: string;
    itemKey: string;
    targetUrl: string;
    filesEnabled: boolean;
    docsEnabled: boolean;
    defaultTemplate: number;
    subject: string;
    senderName: string;
    senderEmail: string;
    receiver: Array<string>;
    cc: Array<string>;
    bcc: Array<string>;
    documentids: string;
    respondeToMailId: string;
    templateLanguageCode: string;
    openLanguageSelection: boolean;
    answerToAll: boolean;
    notAllowedDocumentFileTypes: string[]
}

interface EmailHistoryData {
    type: string;
    jobId: number;
    itemKey: string;
}

interface EmailTemplateEditData {
    templateType: string;
    id: number;
}

interface ActionLocksEditData {
    id: number;
}

interface ActionLocksRightsEditData {
    aktionId: number;
    id: number;
}

interface EmailTemplatesListData {
    templateType: string;
}

interface EmailDataSourceEditData {
    sourceType: string;
    id: number;
}

interface EmailDataSourcesListData {
    sourceType: string;
}

interface CockpitData {
    adrNr: string;
    maschNr: string;
    pos: number;
}

interface ContactData {
    adrNr: string;
}

interface MachineData {
    useSkills: boolean;
    useMachineTypeSkills: boolean;
    address: string;
}

interface TicketData {
    pid: number;
    id: string;
    id2: string;
    id3: string;
    id4: string;
    externalStatusDependsOnTicketType: boolean;
    externalStatusChangesHotliner: boolean;
    cascadingCodes: boolean;
    conversationMode: boolean;
    readOnly: boolean;
    isTIDActive: boolean;
    isCopyMaterialToMashActive: boolean;
}

interface CustomerAppData {
    contextType: string;
    moduleName: string;
    appName: string;
}

interface ProjectData {
    address: string;
    machine: string;
    ticket: number;
    ogrnr: number;
    canAddAssignment: boolean;
}

interface ResourceData {
    standardWorkTime: number;
}

interface SupportZipData {
    subTitle: string;
}

interface ResourcePlanningData {
    mandant: string;
    resourceId: string;
    from: StringOrDate;
    to: StringOrDate;
    geomapEnabled: boolean;
    workHours: number;
    pmLink: number;
    timeZoneEnabled: boolean;
    approvalLevel: number;
    adrNr: string;
    assignmentGroupingActive: boolean;
    copyRessourceGroupingActive: boolean;
    readOnly: boolean;
}

interface ServiceReportListData {
    belegNr: number;
    ursprung: string;
    useThinfinityDgfUrl: boolean;
    ThinfinityDgfUrl: string;
}

interface ServiceReportData {
    projNr: string;
    pIndex: number;
    ressNr: string;
    belegnr: number;
    readOnly: boolean;
}

interface ReourcePlaningGroupingtData {
    projNr: string;
    pIndex: number;
}

interface ResourcePlanningPMData {
    resourceId: string;
    from: StringOrDate;
    to: StringOrDate;
}

interface ReportMachineData {
    projectNo: string;
    pIndex: number
}

interface ReportingData {
    plannedReportId: string;
    reportId: number;
    recordId: string;
    serviceReportId: string;
    position: number;
    type: number;
    machine: string;
    mandant: string;
    pIndex: number;
    recordIsguid: string;
    remark: string;
}


interface ResourcePlanningSchedulerData {
    projNr: string;
    pIndex: number;
    start: string;
    filterId: string;
    onlyMarkAssignment: boolean;
}

interface WeeklyReportListData {
    belegNr: number;
    ursprung: string;
    useThinfinityDgfUrl: boolean;
    ThinfinityDgfUrl: string;
    von: string;
    bis: string;
}

interface WeeklyReportData {
    ressNr: string;
    von: string;
    bis: string;
    stdMinuten: number;
    firstDayOfWeek: number;
    dayOfWeekSaturdayRessource: number,
    dayOfWeekSundayRessource: number,
    isReadonly: boolean
}

interface DirectionsData {
    config: DirectionsConfig;
    title: string;
}

interface ErrorData {
    message: string;
    additionalData: any;
}

interface RemindersData {
    url: string;
}

interface SlaServiceHoursData {
    TypesOfDay: KeyValuePair<number, string>[];
}

export { appLauncher as AppLauncher };

const showAppWithEditorSupport = (component, props) => {
    General.Content.MountComponent(EditorWrapper, { childProps: props, childApp: component });
}

class EditorWrapper extends React.Component<any, { debug: boolean, metadataType?: string, overridenMetadata?: Metadata, metadataChangeKey: string }> {
    constructor(props) {
        super(props);
        this.state = { debug: false, metadataType: props.childProps.metadata.metaDataType, metadataChangeKey: kendo.guid() };
    }

    handleChangeMetadata = (newMetadata: string) => {
        const metadata = Helper.fixMetadata(JSON.parse(newMetadata));
        this.setState({ overridenMetadata: metadata, metadataChangeKey: kendo.guid() })
    }

    render() {
        const newMetadata = { ...this.props.childProps };
        if (Config.user.isSysAdmin && newMetadata?.metadata?.menuDataSource && newMetadata?.metadata?.formatVersion == 2) {
            const menues = this.state?.overridenMetadata?.menuDataSource ?? newMetadata.metadata.menuDataSource as any[];
            const editor = menues.find((i) => i.type == "editor");
            if (!editor && !Helper.useMobileGui()) {
                menues.push({ type: "editor", text: Helper.getTranslation("WebSMS.UI-Editor.open"), onClick: () => { this.setState({ debug: true }); } })
            }
        }
        if (this.state.overridenMetadata) {
            newMetadata.metadata = this.state.overridenMetadata;
            newMetadata.menuEntries = this.state.overridenMetadata.menuDataSource;
            newMetadata.key = this.state.metadataChangeKey;            
        }
        newMetadata.debug = this.state.debug;
        return <>
            {this.state && this.state.debug ? <ConnectedWindow parent={{ entity: this.props.childProps.entity, onChangeMetadata: this.handleChangeMetadata, metadataType: this.state.metadataType }} openAsPopUp={false} moduleName="app/core/components/commonApp" className="Editor" onClose={() => { this.setState({ debug: false }) }} /> : null}
            {React.createElement(this.props.childApp, newMetadata)}
        </>
    }
}